import { Fragment } from 'react';
import {
  minZoom,
  maxZoom,
  canvasBottomMargin,
  canvasPadding,
  canvasSideMargin,
  mouseoverBoxHeight,
  mouseoverBoxWidth,
  changeInTime4KeyPress,
  scaledChangeInDist4KeyPress,
  flipPanelWidth,
  isDevelopment,
  userIsLoggedIn,
  targetFocusDesktopScale,
  navigationHeight,
  moveNavPercentUp,
  // debugCallbackFetchResolveAndPopModal,
  minimal,
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  stageBackgroundDefaultColor,
  imageBasePath,
  dualPedigreeBackgroundHash,
  dualPedigreeLaunchOnDev,
  dualPedigreeMode,
  targetDualPedigreePosX,
  targetDualPedigreePosY,
  defaultBackgroundTextureFileName,
  stagePedigreeSizeObj,
  stagePrintDualPedigreeSizeObj,
  stagePrintPedigreeFanchartSizeObj,
  debug,
  showPrintTree,
} from '../../library/constants';
import {
  isMobilePhone,
  isMobileTablet,
  doWhenReady,
  getNodeFromNodeObjsWithPrId,
  getComputedDomValue,
  wrap,
  isAndroidTablet,
  findDifference,
  isIE,
  isFireFox,
  isWindows,
  centerXFanchart,
  centerYFanchart
} from '../../library/calc';
import assets from './assets';
import {
  Flippanel,
  PreferencesDesktop,
  DualPedigreePanel,
  DualPedigreeCenterResizePicModal,
  DualPedigreeChangeNameModal,
  InviteModal,
  VerticalSlider,
  Resolve,
  ProductTour,
  PrintModalDesktopWithDualPedigreeOption,
  MoveHelp,
  MoveDecisionPanel,
  FloaterPanel,
  Navigation,
  Legend,
} from './codesplitting';

import { Addbox, CalloutTriTip } from '../../components/Pedigree/Addbox';
import Pan from '../../components/Pan';
import Config from '../../components/Config';
import SwitchTree from '../../components/SwitchTree';
import CornerMessage from '../../components/CornerMessage';
import PrintTreeIcon from '../../components/PrintTree/icon';
import { HelpIcon } from '../../components/ProductTour/icon';
import Move from './4_move';
import anime from 'animejs';
import { throttle } from 'lodash';
import smoothscroll from 'smoothscroll-polyfill';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";  // https://pdfmake.github.io/docs/document-definition-object/styling/
import { cloneDeep } from 'lodash';
smoothscroll.polyfill(); // http://iamdustan.com/smoothscroll/
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class Desktop extends Move {

  refObj = {};
  buildRefObj({key, objClass}){
    this.refObj[key] = objClass;
  }

  defineWindowCanvasRefObj(){
    setTimeout(() => {
      window.canvasRefObj = this.refObj;
    }, 1000);
  }

  callRefObj({key, method, param}){

    if( typeof(this.refObj[key]) !== 'undefined' && typeof(this.refObj[key][method]) !== 'undefined' ){
      this.refObj[key][method](param);
    }

  }

  /**
   *
   *
   *  OnClick Events
   *
   *
   *
   */

  onClickDelete(node){

    // if(isDevelopment) {
    //   console.log('You are on development');
    //   return;
    // }

    this.stopStageClickPropagation({fromWhere: 'onclickedDelete'});
    this.delayStageClickCanZoomStep();
    const pr_id = this.nodeObjs[node].pr_id;
    window.deleteNode(pr_id);
    setTimeout(() => {
      window.deleteNodeMessage.close();
    }, 2000);
  }

  nodeWasClickedTooMuch(){
    const throttleMilisec = 700;
    if(!this.nodeCanBeClicked){
      return true;
    } else{
      this.nodeCanBeClicked = false;
      setTimeout(() => {
        this.nodeCanBeClicked = true;
      }, throttleMilisec);
      return false;
    }
  }

  openAddNodeForm({node, relationShip, marriageId, nodeIsGhost}){

    this.hideNotificationModal({});
    this.hideProductTour({fromWhere: 'bb', withLastStepNotify: true});
    this.cleanUp({closePedigreeAddbox: false});
    // this.unsetFlipPanelOpen();
    // this.toggleFlipPanel({close: true, from: 'openAddNodeForm'});

    const callback = () => {

      const nodeHasNearbyTreeMatches = () => {
        return typeof(this.props.nodeObjs[node].ntm) !== 'undefined' && this.props.nodeObjs[node].ntm === 1;
      }

      if( nodeHasNearbyTreeMatches() ){
        // console.log('D');
        this.showHookMessageForNearbyTreeMatches({node});

      } else {

        this.showProgressIndicator();
        if(typeof(this.props.nodeObjs[node].addNodeObj) !== 'undefined'){

          const addNodeObj = this.props.nodeObjs[node].addNodeObj;
          const { choice, marriageId } = addNodeObj;
          let { pr_id } = addNodeObj;
          if(typeof(pr_id) === 'undefined') pr_id = null;
          window.openAddNode(pr_id, choice, marriageId);

        } else{

          // console.log(`openAddNode parameters: `, JSON.stringify({pr_id:this.nodeObjs[node].pr_id, relationShip, marriageId}, null, 2));

          window.openAddNode(this.props.nodeObjs[node].pr_id, relationShip, marriageId);

          // console.log(`openAddNode parameters: `, JSON.stringify({pr_id:this.nodeObjs[node].pr_id, relationShip, marriageId}, null, 2));

        }

      }


    }

    this.delayStageClickCanZoomStep();
    if(this.props.isPedigree || typeof(nodeIsGhost) !== 'undefined' || this.props.isFanChart){
      callback();
    } else{
      this.panAnimateToNode({node, targetScale: targetFocusDesktopScale, callback});
    }
  }

  sameNodeWasClicked(node){

    if(this.state.nodeForFlipFocus === node){
      if(this.state.flipPanelOpened){
        this.toggleFlipPanel({close: true, from:'onClickedNode A'});
      } else {
        // const callback = () => {
          this.toggleFlipPanel({node, from:'onClickedNode B'});
        // }

        // this.zoomAnimateToNode({ node, targetScale: maxZoom, callback } );
      }
      return true;
    } else{
      if(!this.state.flipPanelOpened){
        this.setCurZoomScaleWhenClicked();
      }
      return false;
    }

  }

  isNodeThatCanDragForCntrlMove({nodeObj}){
    return nodeObj.nt === 'ghost'  ||  typeof(nodeObj.nvp) === 'number'
  }

  doOnCntrlMoveClickedMoveTarget(node){
    this.enableMouseOverStageToFindDropTargetForMoveDropOnTarget(true);
    this.setCntrlDragNodeObj(node);
  }

  onClickedFullName({prId, node}){

    this.stopStageClickPropagation({fromWhere: 'onClickedFullName method'});
    this.cleanUp({closePedigreeAddbox: true});
    // if(!userIsLoggedIn) return;
    if(this.nodeWasClickedTooMuch()) return;
    const href = '/profile/index/' + prId;
    window.open(href, '_blank');
  }

  setCurZoomScaleWhenClicked(){
    this.curZoomScaleBeforeClick = this.stage.current.scaleX();
  }

  onClickedNode(node){
/*

    if( this.props.isFanChart ){

      if( isDevelopment){
        console.log('Development');
        return;
      }

      this.setState({ nodeForFlipFocus: node });

      setTimeout(() => {


           console.log(`%c toggleFlipPanel`, [
             'color: white',
             'background: orange',
             'font-size: 14px',
             'border: 5px solid red',
             'padding: 10px',
             ].join(';'));


        const allowComponentToUpdateCallback = () => {
          this.allowComponentUpdate(true);
        }

        this.toggleFlipPanel({node, close: false, allowComponentToUpdateCallback, from: 'onClickedNode'});

      }, 1000);

      return;
    }
 */

    if(this.props.nodeObjs[node].nt !== 'ghost') this.allowComponentUpdate(false);

    this.setState({ nodeForFlipFocus: undefined });

    if(minimal ) return;

    if(this.props.isPedigree) this.setPedigreeAddbox({visible: false});

    window.callFlipPanelComponentUpdate({once: true, fromWhere:  'onClickedNode'})

    this.highlight(node);
    setTimeout(() => {
      this.unhighlight(node);
    }, 3000);

    this.stopStageClickPropagation({fromWhere: 'onClickedNode method'});

    this.cleanUp({closePedigreeAddbox: false});
    this.hideNotificationModal({});

    if(this.isNoViewProfile(node)){
      console.log('do not open');
      return;
    }

    if(!userIsLoggedIn) return;
    if(this.nodeWasClickedTooMuch()) return;


    if(this.nodeIsGhost({nodeObj: this.props.nodeObjs[node], n: node})) {
      this.openAddNodeForm({node});
      return;
    }

    if(this.sameNodeWasClicked(node)) return;

    if(this.props.isPedigree || this.props.isFanChart){

      if(this.props.isFanChart) this.fanChartComponent.current.allowComponentUpdate(false)

      this.setState({
        nodeForFlipFocus: node,
        pedigreeAddboxVisible: false,
      });

      setTimeout(() => {

        const allowComponentToUpdateCallback = () => {
          this.allowComponentUpdate(true);
        }

        const callback = ()=>{
          if(this.props.isFanChart) this.fanChartComponent.current.allowComponentUpdate(true)
        }

        this.toggleFlipPanel({node, close: false, allowComponentToUpdateCallback, from: 'onClickedNode', callback});
      }, 400);

    } else{


      this.stageClickCanCloseFlipPanel = false;

      const panAfterFlipOpenCallback = () => {

        this.setState({ nodeForFlipFocus: node });
        const allowComponentToUpdateCallback = () => {
          this.allowComponentUpdate(true);
        }

        this.flipPanelOpenAfterAnimateComplete = false;
        if( this.state.productTourVisible ){
          allowComponentToUpdateCallback();
          return;
        }
        this.panAnimateToNode({ node,
          targetScale: 5,
          onlyPan: true,
          skipScrollTo: false,
          allowComponentToUpdateCallback,
        });
      }

      this.toggleFlipPanel({
        node,
        from: 'doOnLastScale',
        panAfterFlipOpenCallback,
      });
    }

  }

  onClickedInvite({node, prId}){
    this.hideNotificationModal({});
    this.allowComponentUpdate(false);
    this.stopStageClickPropagation({fromWhere: 'onclickedInvite'});
    this.cleanUp({closePedigreeAddbox: true});
    if( this.state.flipPanelOpened ) this.toggleFlipPanel({close: true, from: 'onClickedInvite'});

    const inviteCallback = () => {
      this.allowComponentUpdate(true);
      const fullName = this.nodeObjs[node].nm;
      this.setInviteNode({node, prId, fullName});
      this.showInviteModal();
    }

    this.setCurZoomScaleWhenClicked();

    const targetScale = 5;
    this.panAnimateToNode({ node, targetScale, inviteCallback });

    this.stageClickCanZoomStep = false;
    this.stageClickCanCloseFlipPanel = false;
    setTimeout(() => {
      this.stageClickCanZoomStep = true;
      this.stageClickCanCloseFlipPanel = true;
    }, 1000);
  }

  setShowLegendModal(how){
    this.setState({
      showLegendModal: how,
    })
  }


  oldSliderValue: null

  doWhenSliderValueChanges(sliderValue){

    if(this.oldSliderValue !== sliderValue){
      this.cleanUp({closePedigreeAddbox: true});
      const scale = sliderValue * .1;
      this.stage.current.scale({ x: scale, y: scale});

      const posObj = {
        x: this.getCurStagePos().x,
        y: this.getCurStagePos().y
      };

      this.stage.current.position(posObj);
      this.stage.current.batchDraw();

      this.oldSliderValue = sliderValue;
    }

  }

  desktopVerticalSliderStart(){ }

  /*

      const newScale = sliderValue * 0.1;

      if (newScale < minZoom || newScale > maxZoom) return;

      let zoomCenterX = (this.stage.current.width() / 2);
      let zoomCenterY = (this.stage.current.height() / 2);

      this.stage.current.scaleX(newScale);
      this.stage.current.scaleY(newScale);

      const newPos = {
        x: -zoomCenterX * newScale + this.stage.current.width() / 2,
        y: -zoomCenterY * newScale + this.stage.current.height() / 2,
      };

      this.stage.current.position(newPos);

      this.zoomFanChart({newScale, newPos});

   */

  desktopVerticalSliderZoom( sliderValue ){


    if(this.props.isFanChart){

      const SCALE_FACTOR = 0.1;
      if (!this.stage?.current) return;

      const stage = this.stage.current;
      const oldScale = stage.scaleX(); // Assumes uniform scaling (scaleX === scaleY)
      const newScale = Math.max(minZoom, Math.min(maxZoom, sliderValue * SCALE_FACTOR));

      if (newScale === oldScale) return; // Prevent redundant updates

      // Fan chart center relative to the stage
      const fanChartCenterX = 700;
      const fanChartCenterY = 545;

      // Current position of the stage
      const stagePosition = stage.position();
      const stageX = stagePosition.x;
      const stageY = stagePosition.y;

      // Compute the zoom adjustment
      const zoomRatio = newScale / oldScale;
      const newPos = {
        x: fanChartCenterX - (fanChartCenterX - stageX) * zoomRatio,
        y: fanChartCenterY - (fanChartCenterY - stageY) * zoomRatio,
      };

      // Apply scaling and repositioning
      stage.scaleX(newScale);
      stage.scaleY(newScale);
      stage.position(newPos);

      this.zoomFanChart({ newScale, newPos });


    } else {

      this.doWhenSliderValueChanges(sliderValue);
      this.calcNewStageCenterNodePos();

    }
    this.redraw({});
    this.setState({sliderValue, firstTreeMatchCountNotify: false, firstRecordMatchCountNotify: false,})
  }

  desktopVerticalSliderStop(){ }

  chooseFrameTypeDualPedigree({frameStyle}){

    // this.setState({
    //   frameStyle,
    // })

    // const callFetchTree = () => {
    //  this.reloadCanvasTree(this.props.dualPedigreeObj.focusPrId, { unionId: this.props.dualPedigreeObj.unionId });
    // }

    this.props.postPoster({
      action: 'saveCustomDataFrameType',
      frameStyle,
      /*callFetchTree*/});

    /*

                const posters = this.props.dualPedigreeObj.posters;

            let otherTpId = undefined;

            posters.forEach((obj)=>{
              if(obj.unionId === unionId) otherTpId = obj.tpId;
            });

            const callReloadCanvasTree = (prId) => {
              this.props.reloadCanvasTree(prId, { unionId });
            }

            if( typeof(otherTpId) !== 'undefined'  ){
              this.props.postPoster({ action: 'fetchfocusPrId', tpId:  otherTpId, callReloadCanvasTree});
            } else {

              const focusPrId = this.props.dualPedigreeObj.focusPrId;
              this.props.reloadCanvasTree(focusPrId, { unionId });

            }
     */
  }

  dualPedigreeBackgroundUserPrefenrenceIsReady = false;
  chooseBackgroundTextureDualPedigree({backgroundTextureFileName}){

    this.dualPedigreeBackgroundUserPrefenrenceIsReady = false;

    this.setState({
      dualPedigreeBackgroundTextureFileName: backgroundTextureFileName,
    })

    const callSetBackgroundTextureDualPedigree = () => {
      this.setBackgroundTextureDualPedigree();
    }

    this.props.postPoster({
      action: 'saveBackgroundTexture',
      backgroundTextureFileName,
      callSetBackgroundTextureDualPedigree,
    });

  }

  chooseTitleBorderDualPedigree({titleBorder, none}){
    this.props.postPoster({
      action: 'chooseTitleBorder',
      titleBorder: ( typeof(none) === 'undefined'  ? titleBorder: undefined)
    });

  }

  chooseFontFamilyDualPedigree({fontFamily}){

    this.props.postPoster({
      action: 'chooseFontFamily',
      fontFamily
    });

  }

  showWhichChildren({whichChildrenNode}){

    this.props.postPoster({
      action: 'whichChildrenNode',
      whichChildrenNode
    });

  }

  includeDate({includeDate}){

    this.props.postPoster({
      action: 'includeDate',
      includeDate
    });

  }

  setBackgroundTextureDualPedigree(){

    this.backgroundStageImg = new window.Image();

    if(

      !dualPedigreeLaunchOnDev  &&

      typeof(this.props.dualPedigreeObj.backgroundTextureFileName) !== 'undefined' &&
      typeof(dualPedigreeBackgroundHash[this.props.dualPedigreeObj.backgroundTextureFileName]) !== 'undefined'

    ){

      const filename  = this.props.dualPedigreeObj.backgroundTextureFileName + '.' + dualPedigreeBackgroundHash[this.props.dualPedigreeObj.backgroundTextureFileName].ext
      this.backgroundStageImg.src = imageBasePath  + `dualpedigree/backgroundtextures/${filename}`;

    } else {
      this.backgroundStageImg.src = imageBasePath  + `dualpedigree/backgroundtextures/${defaultBackgroundTextureFileName}.${dualPedigreeBackgroundHash[defaultBackgroundTextureFileName].ext}`;

    }


    // console.log(`this.backgroundStageImg.src: `, this.backgroundStageImg.src);

    this.backgroundStageImg.crossOrigin = "Anonymous";

    this.backgroundStageImg.onload = () => {

      this.dualPedigreeBackgroundUserPrefenrenceIsReady = true;
      this.forceUpdateCanvas('setBackgroundTextureDualPedigree');

    }


  }

  tweakFrameTypeDimDualPedigree({innerFrameSideLengthAdjust, innerFrameSideDownAdjust, innerFrameSideRightAdjust}){
    this.setState({innerFrameSideLengthAdjust, innerFrameSideDownAdjust, innerFrameSideRightAdjust});
  }

  showInviteModal(){
    this.setState({
      showInviteModal: true,
    })
  }

  fillMatchBubbleContent({matchBubbleContent, matchBubbleContentVarStr}){
    this.setState({
      matchBubbleContent,
      matchBubbleContentVarStr,
    })
  }

  setCanHideInviteModal(bool){
    this.canHideInviteModal = bool;
  }

  hideInviteModal(){
    if(!this.canHideInviteModal) return;
    setTimeout(() => {
      this.zoomBackToLevelBeforeClick();
    }, 1000);
    this.setState({
      showInviteModal: false,
      inviteNode: null,
      invitePrId: null,
    })
  }

  setInviteNode({node, prId, fullName}){
    this.setState({
      inviteNode: node,
      invitePrId: prId,
      inviteFullName: fullName
    })
  }

  setFlipPanelOpen(){
    this.setState({
      flipPanelOpened: true
    });
    // window.callFlipPanelComponentUpdate({fromWhere: 'R'});
    if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();
  }

  unsetFlipPanelOpen(){
    this.setState({
      flipPanelOpened: false
    })
    this.flipPanelOpenAfterAnimateComplete = false;
  }

  setDualPedigreePanelChoices({dualPedigreePanelTabOn, dualPedigreeCollapseChoice}){
    this.setState({dualPedigreePanelTabOn, dualPedigreeCollapseChoice})
  }

  unsetFirstTreeMatchCountNotify(){

    const obj = {
      firstTreeMatchCountNotify: false,
    };

    this.setState(obj);

  }

  unsetFirstRecordMatchCountNotify(){

    const obj = {
      firstRecordMatchCountNotify: false,
    };

    this.setState(obj);

  }

  setCustomColors({maleCustomColor, femaleCustomColor, unGenderedCustomColor, stageBackgroundCustomColor}){

    this.setState({maleCustomColor, femaleCustomColor, unGenderedCustomColor, stageBackgroundCustomColor});

  }

  resetToDefaultColors(){

    let setObj = {
      maleCustomColor: maleDefaultColor,
      femaleCustomColor: femaleDefaultColor,
      unGenderedCustomColor: unGenderedDefaultColor,
      stageBackgroundCustomColor: stageBackgroundDefaultColor
    }

    this.setState(setObj);

  }

  resetNavigationState(){

    const obj = {
      allProfilesFetched: false,
      gotoComponentEnabled: false,
      navigationPanelIsUp: false,
      mapNavTabActive: false,
      gotoNavTabActive: false,
      firstTreeMatchCountNotify: false,
      firstRecordMatchCountNotify: false,
    };

    // console.log('Setting local state: ' + JSON.stringify(obj, null, 2));

    this.setState(obj);

  }

  setNavigationOpen({how}){
    this.setState({
      navigationPanelIsUp: how
    })
  }

  setGotoNavTabActive({toggle, how}){

    this.visitedCount++; this.visited['setGotoNavTabActive'] = this.visitedCount;

    if(typeof(toggle) !== 'undefined' ){
      if(this.state.gotoNavTabActive){
        this.setState({
          gotoNavTabActive: false
        })
      } else {
        this.setState({
          gotoNavTabActive: true
        })
      }
    }
    if(typeof(how) !== 'undefined' ){
      this.setState({
        gotoNavTabActive: how
      })
    }
  }

  setMapNavTabActive({toggle, how}){
    if(typeof(toggle) !== 'undefined' ){
      if(this.state.mapNavTabActive){
        this.setState({
          mapNavTabActive: false
        })
      } else {
        this.setState({
          mapNavTabActive: true
        })
      }
    }
    if(typeof(how) !== 'undefined' ){
      this.setState({
        mapNavTabActive: how
      })
    }
  }

  zoomBackToLevelBeforeClick(){
    if(this.props.isPedigree){
      this.zoomAnimateCenterPedigree()
      return;
    }
    if(typeof(this.curZoomScaleBeforeClick) !== 'undefined' && this.curZoomScaleBeforeClick !== 0){
      const target = this.curZoomScaleBeforeClick;
      this.zoomInOutStepping({target});
    }
  }

  delayWhenStageClickCanToggleFlipPanel(){
    setTimeout(() => {
      this.stageClickCanCloseFlipPanel = true;
    }, 700);
  }

  makeDesktopControlsVisible(){

    const domElArray = [
      'mouseOverRightBox',
      'mouseOverLeftBox',
      'mouseOverTopBox',
      'mouseOverBottomBox',
    ];
    domElArray.forEach((element)=>{
      document.getElementById(element).style.visibility = 'visible';
    })

    // document.getElementById('NavigationPanel').click();

  }

  applyAlternateColorShadingToNavigationGotoCols({going}){

    const isOddIdx = (idx) => {
      return idx % 2
    }

    const whenColNavComponentsIsRendered = () => {
      return document.querySelectorAll(".colNavComponent").length;
    }

    const highlightColumns = () => {

      const colNavComponents = document.querySelectorAll(".colNavComponent");
      if(going === 1){

        for (let idx = 0; idx < colNavComponents.length; idx++) {
          colNavComponents[idx].style.backgroundColor = `white`;
        }

      } else {

        for (let idx = 0; idx < colNavComponents.length; idx++) {
          colNavComponents[idx].style.backgroundColor = ( isOddIdx(idx) ? `#EFEFEF`: `white`);
        }

      }
    }

    doWhenReady({argument: '', condition: whenColNavComponentsIsRendered, callback: highlightColumns, attempts: {ongoing:0, end: 10}, fromWhere: 'applyAlternateColorShadingToNavigationGotoCols'})

  }

  navigationIsUp = false;
  navigationShiftUp = 0;

  resetNavDirectionControls(){

    if(isMobilePhone() ) return;

    this.navigationIsUp = false;
    this.setNavigationOpen({how: false})
    this.unsetFlipPanelOpen();
    this.navigationShiftUp = 0;

    var divs = document.querySelectorAll('.desktopBoxControls');
      [].forEach.call(divs, function(div) {
        div.style.transform = 'translateX(0px) translateY(0px)'
    });

    document.getElementById('mouseOverBottomBox').style.transform = 'translateX(0px) translateY(0px)'
    document.getElementById('mouseOverLeftBox').style.transform = 'translateX(0px) translateY(0px)'
    document.getElementById('mouseOverRightBox').style.transform = 'translateX(0px) translateY(0px)'

    let delay = 500;
    const duration = 400;
    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['.desktopBoxControls',
                '.switchTreeIcons',
                '#printTreeIcon',
                '#mouseOverBottomBox',
                '#mouseOverLeftBox',
                '#mouseOverRightBox',
                '#mouseOverBottomBox'],
      translateX: 0,
      translateY: 0,
    });

  }

  toggleNavigationalPanel({direction, toggle, switchToDefaultTree, callback}){

    if(dualPedigreeMode) return;

    if(isMobileTablet()) this.hideProductTour({fromWhere: 'Q', withLastStepNotify: true});

    if( typeof(window.forceHideMoreList) === 'function' )  window.forceHideMoreList();

    let going = undefined
    if(typeof(toggle) !== 'undefined'){
      if(this.navigationIsUp){
        going = 1;
        this.navigationIsUp = false;
      } else {
        going = -1;
        this.navigationIsUp = true;
      }
    } else {
      if(direction === 'up'){
        going = -1;
        this.navigationIsUp = true;
      } else{
        this.navigationIsUp = false;
        going = 1;
      }
      if(direction === 'down'){
        going = 1;
        this.navigationIsUp = false;
      } else{
        this.navigationIsUp = true;
        going = -1;
      }
    }


    let delay = 500;
    const duration = 400;

    const that = this;
    if(going === 1){
      // document.getElementById("navigationTabContentStretchedWrapper").style.background = '#FFFFFF';
      if(document.getElementById("navigationTabContentStretchedWrapper")) document.getElementById("navigationTabContentStretchedWrapper").style.background = '#EFEFEF';
      this.setNavigationOpen({how: this.navigationIsUp});
      this.setGotoComponentEnabled(true);
    } else {
      // document.getElementById("navigationTabContentStretchedWrapper").style.background = '#EFEFEF';
      // document.getElementById("navigationTabContentStretchedWrapper").style.background = 'brown';
    }

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['#NavigationPanel'],
      translateY: going * (navigationHeight/moveNavPercentUp),
      begin: function(anim) {
        if(going === -1 && that.state.gotoNavTabActive){
          that.fetchEveryProfile();
        }
      },
      complete: () =>{
        if(that.state.gotoNavTabActive && going === -1){
          that.applyAlternateColorShadingToNavigationGotoCols({going})
        }

        /*
         *
         *
         * hackTab for chrome browser bug where overflow: scroll not functioning when translateY applied
         *
         *
         *
         */

         if(going === -1){


          if(document.getElementById('hackTab')) document.getElementById('hackTab').style.display = 'none';
          setTimeout(() => {
            if(document.getElementById('hackTab')) document.getElementById('hackTab').style.display = 'block';
          }, 1000);


          this.setNavigationOpen({how: this.navigationIsUp});

          if(this.state.flipPanelOpened ) window.callFlipPanelComponentUpdate({once: true, fromWhere: 'C'})

          // document.getElementById("navigationTabContentStretchedWrapper").style.background = '#FFFFFF';
          // document.getElementById("navigationTabContentStretchedWrapper").style.background = '#FFFFFF';

         } else {

          // document.getElementById("navigationTabContentStretchedWrapper").style.background = '#EFEFEF';

          if(this.state.flipPanelOpened ) window.callFlipPanelComponentUpdate({once: true, fromWhere: 'D'})
          if(typeof(switchToDefaultTree) !== 'undefined'){
            switchToDefaultTree()
          }
         }

      }
    });


    const shiftUp = 50;

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['#mouseOverBottomBox'],
      translateX: ( this.state.flipPanelOpened ? 185: 0),
      translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0)),
    });

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['#mouseOverLeftBox'],
      translateX: ( this.state.flipPanelOpened ? 370: 0),
      translateY: going * (( going < 0 ? (navigationHeight) - shiftUp: 0)),
    });

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['#mouseOverRightBox'],
      translateY: going * (( going < 0 ? (navigationHeight) - shiftUp: 0)),
    });

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['.switchTreeIcons',  '#printTreeIcon'],
      translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0)),
      complete: () =>{
        if(typeof(callback) !== 'undefined' ) callback()
      }
    });

    anime({
      easing: 'easeInOutQuart',
      duration,
      delay,
      targets: ['.desktopBoxControls'],
      // translateX: ( this.state.flipPanelOpened ? 370: 0),
      translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0)),
    });

    if(going < 0){
      this.navigationShiftUp = -navigationHeight;
    } else {
      this.navigationShiftUp = 0;
    }

  }

  toggleFlipPanel({
    node,
    prId,
    close,
    callback,
    skipLoadFlipPanel,
    panAfterFlipOpenCallback,
    allowComponentToUpdateCallback,
    from,
  }){

    if(dualPedigreeMode || dualPedigreeLaunchOnDev) {
      return;
    }

    if( typeof(this.props.nodeObjs) === 'undefined') return;

    if( typeof(this.props.nodeObjs[node]) !== 'undefined' &&
        typeof(this.props.nodeObjs[node].nt) !== 'undefined' &&
        this.props.nodeObjs[node].nt === 'ghost'){
      close = true;
    }

    let going = undefined
    if(this.navigationIsUp){
      going = -1
    } else {
      going = 1;
    }

    let moveHalfShift = null;
    let moveFullShift = null;
    let moveFullReverse = null;
    let delay = 0;
    const duration = 400;

    const shiftUp = 50;

    if( close ){

      if( typeof(this.state.nodeForFlipFocus) !== 'undefined' &&
          this.state.nodeForFlipFocus !== null){
            this.setState({ nodeForFlipFocus: undefined });
            if(this.props.chartType === 'fan') this.fanChartComponent.current.highlightFromSidePanel({prId:0})
      }

      delay = 0;
      moveHalfShift = 0;
      moveFullShift = 0;
      moveFullReverse = -1 * flipPanelWidth;

      if(this.state.flipNodeCrumbs.length > 0){
        this.setState({
          flipNodeCrumbs: []
        });
      }

    } else {

      if(typeof(skipLoadFlipPanel) === 'undefined') {

        // window.callFlipPanelComponentUpdate({once: false, fromWhere: 'toggleFlipPanel'});
        // const doAfterNodeIsDefined = ({node, doWhatToFlipNodeCrumbs}) => {
        //   this.changeFlipNodeCrumbs({doWhatToFlipNodeCrumbs: 'add', node})
        // }

        // this.loadFlip({
        //     node,
        //     prId: this.props.nodeObjs[node].pr_id,
        //     doAfterNodeIsDefined,
        // })

        const doAfterNodeIsDefined = ({node, doWhatToFlipNodeCrumbs}) => {
          this.changeFlipNodeCrumbs({doWhatToFlipNodeCrumbs: 'add', node})
        }

        if (this.props.nodeObjs && node && this.props.nodeObjs[node]) {
          this.loadFlip({
            node,
            prId: this.props.nodeObjs[node].pr_id,
            doAfterNodeIsDefined,
          });
        }

      }

      moveHalfShift = flipPanelWidth / 2;
      moveFullShift = flipPanelWidth;
      moveFullReverse = 0;
    }

    const genObj = {
      easing: 'easeInOutQuart',
      duration,
      delay,
    }

    anime({
      ...genObj,
      targets: ['#stageWrapper', '#mouseOverTopBox', '#addBox-callout', '#addBox-tritip'],
      translateX: moveHalfShift
    });

    /*
     *
     *  mouseOverRightBox
     *
     */

    let mouseOverRightBox = {
      ...genObj,
      targets: ['#mouseOverRightBox'],
    }

    if(this.navigationIsUp){
      mouseOverRightBox = {
        ...mouseOverRightBox,
        translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0))
      }
    }

    anime(mouseOverRightBox);

    /*
     *
     *  mouseOverBottomBox
     *
     */

    let targetsHalfShift = ['#mouseOverBottomBox'];

    let mouseOverBottomBoxObj = {
      ...genObj,
      targets: targetsHalfShift,
      translateX: moveHalfShift,
      translateY: going * (( going < 0 ? navigationHeight: 0)),
    }

    if(this.navigationIsUp){
      mouseOverBottomBoxObj = {
        ...mouseOverBottomBoxObj,
        translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0))
      }
    }

    anime(mouseOverBottomBoxObj);

    /*
     *
     *  mouseOverLeftBox
     *
     */

    let mouseOverLeftBoxObj = {
      ...genObj,
      targets: ['#mouseOverLeftBox'],
      translateX: moveFullShift,
    }

    if(this.navigationIsUp){
      mouseOverLeftBoxObj = {
        ...mouseOverLeftBoxObj,
        translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0))
      }
    }

    anime(mouseOverLeftBoxObj);

    /*
     *
     *  desktopBoxControls
     *
     */

    let deskTopControlsObj = {
      ...genObj,
      targets: ['.desktopBoxControls'],
      translateX: moveFullShift,
    }

    if(this.navigationIsUp){
      deskTopControlsObj = {
        ...deskTopControlsObj,
        translateY: going * (( going < 0 ? navigationHeight - shiftUp: 0))
      }
    }
    anime(deskTopControlsObj);

    /*
     *
     *  flip-panel
     *
     */

    anime({
      ...genObj,
      targets: ['#flip-panel'],
      translateX: moveFullReverse,
      begin: function(anim) {

      },
      complete: () =>{
        if( close ){
          this.unsetFlipPanelOpen();
          if(typeof(callback) !== 'undefined') callback()
        } else {
          if(typeof(callback) !== 'undefined' && this.props.isFanChart) callback()

          this.setFlipPanelOpen();

          if(typeof(allowComponentToUpdateCallback) !== 'undefined' ){
            allowComponentToUpdateCallback()
          }
          if(typeof(panAfterFlipOpenCallback) !== 'undefined' ){
            panAfterFlipOpenCallback()
          }

        }
      }
    });

    this.delayWhenStageClickCanToggleFlipPanel();


  }

  dropChoiceMessageOpened = false;
  toggleDropChoiceMessage(){

    let delay = 100;
    const duration = 100;

    const genObj = {
      easing: 'easeInOutQuart',
      duration,
      delay,
    }

    let translateX = 0;

    if( this.dropChoiceMessageOpened){
      translateX = 460;
      this.dropChoiceMessageOpened = false;
    } else {
      this.dropChoiceMessageOpened = true;
      translateX =  -460
    }


    anime({
      ...genObj,
      targets: ['#dropChoiceMessage'],
      translateX
    });

  }

  cursorBecomesPointer(){
    if(this.isDraggingFloater){
      this.stage.current.container().style.cursor = 'move';
    } else{
      this.stage.current.container().style.cursor = 'pointer';
    }

  }

  cursorBecomesMove(){
    this.stage.current.container().style.cursor = 'move';
  }

  showflipPanelAfterAnimateComplete(){
    return this.state.nodeForFlipFocus &&
          this.flipPanelOpenAfterAnimateComplete;
  }

  setFlipPanelOpenAfterAnimateComplete({how}){
    this.flipPanelOpenAfterAnimateComplete = how;
  }

  setMouseOverBoxDisplay = (which, how) => {
    if( !minimal  && !isMobileTablet() && userIsLoggedIn && !dualPedigreeMode && typeof(this.refs[which]) !== 'undefined' ){
      const defaultClasses = 'mouseoverBox box ';
      if(how) this.refs[which].className = defaultClasses;
      else this.refs[which].className = defaultClasses + 'hidden'
    }
  }

  updateVerticalSliderZoom(){

    if(!this.stage) return;
    const sliderValue = Math.round(this.stage.current.scaleX() * 10);
    this.setState({sliderValue})

  }


  hidePedigreeAddbox(){

    this.setState({
      pedigreeAddboxVisible: false,
    })

  }

  setPedigreeAddbox({left, top, visible, node, sideOfCircle}){

    if( !visible ){
      this.setState({
        pedigreeAddboxVisible: false,
      })
      if(this.props.isFanChart){
        this.fanChartComponent.current.allowComponentUpdate(true);
        this.fanChartComponent.current.setHighlightFrozen(0)
      }
    }

    // if(seePedigreeAddboxConsoleLog) console.log(`setPedigreeAddbox`, JSON.stringify({left, top, visible, node}, null, 2));

    // if(typeof(node) !== 'undefined') {
    //   this.props.branches.forEach((branch) => {
    //     branch.node !== node && this.refs[`node-tab-${branch.node}`] && this.refs[`node-tab-${branch.node}`].setTabVisible({addTabVisible: true});
    //     branch.node !== node && this.refs[`node-tabstr-${branch.node}`] && this.refs[`node-tabstr-${branch.node}`].setTabVisible({addTabVisible: true});
    //   })
    //   // this.refs[`node-tab-${node}`].setTabVisible({addTabVisible: false});
    //   this.refs[`node-tabstr-${node}`].setTabVisible({addTabVisible: false});
    // }

    // if(!visible && typeof(this.props.branches) !== 'undefined'){
    //   // console.trace('setPedigreeAddbox when !visible');
    //   this.props.branches.forEach((branch) => {
    //     this.refs[`node-tab-${branch.node}`] && this.refs[`node-tab-${branch.node}`].setTabVisible({addTabVisible: true});
    //     this.refs[`node-tabstr-${branch.node}`] && this.refs[`node-tabstr-${branch.node}`].setTabVisible({addTabVisible: true});
    //   })
    // }


    if(typeof(node) !== 'undefined' && typeof(this.props.nodeObjs[node]) !== 'undefined'){

      const nodeObj = this.props.nodeObjs[node];
      if(typeof(nodeObj.hasMoreAdd) !== 'undefined' && nodeObj.hasMoreAdd){
        this.showHookMessageNeedForReload(nodeObj.prId);
      } else {

        let obj = {
          pedigreeAddboxVisible: visible,
          pedigreeAddboxLeft: left,
          pedigreeAddboxTop: top,
          pedigreeAddboxNode: node,
          warnPublic: false,
          prIdForWarning: undefined,
        };

        if( sideOfCircle && this.props.isFanChart){
          obj = {...obj, ...{whichSideTip: sideOfCircle}}
        }
        this.setState(obj)

        if(typeof(nodeObj.immediateFam) === 'undefined' && !isDevelopment){
          this.props.fetchImmediateFamily({focusPrId: nodeObj.pr_id, focusNodeId: nodeObj.n, focusGender: nodeObj.g, forWhat: 'pedgreeAddbox'})
        };
      }
    }


  }

  fetchResolveAndPopModal({prId}){

    this.visitedCount++; this.visited['fetchResolveAndPopModal'] = this.visitedCount;

    const canEditProfile = (node) => {
      return  typeof(this.props.nodeObjs[node]) !== 'undefined' &&
        typeof(this.props.nodeObjs[node].flipData) !== 'undefined' &&
        typeof(this.props.nodeObjs[node].flipData.display.action_edit) !== 'undefined' &&
        this.props.nodeObjs[node].flipData.display.action_edit;
    }

    const continueFetchResolveAndPopModal = () => {

        this.aleadyFetchedResolveAndPopModal = true;
        this.hideNotificationModal({});
        this.stopStageClickPropagation({fromWhere: 'fetchResolveAndPopModal'});
        const setObj = {resolvePrId: prId};
        this.setState(setObj);
        this.setResolveVisible(true);
    }

    const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId});

    if( canEditProfile(node) ){

      continueFetchResolveAndPopModal();

    } else {

      this.props.fetchFlipData({
        node,
        pr_id: prId,
        callSetNodeObjPic: undefined,
        callback: continueFetchResolveAndPopModal,
      });

    }

  }

  testResolveAndPopModal(){

    const continueFetchResolveAndPopModal = () => {

         console.log(`%c continueFetchResolveAndPopModal`, [
         'color: white',
         'background: purple',
         'font-size: 14px',
         'border: 5px solid red',
         'padding: 10px',
         ].join(';'));

        this.aleadyFetchedResolveAndPopModal = true;
        this.hideNotificationModal({});
        this.stopStageClickPropagation({fromWhere: 'fetchResolveAndPopModal'});
        const setObj = {resolvePrId: 57};
        this.setState(setObj);
        this.setResolveVisible(true);
    }

    this.props.fetchFlipData({
      node: 6,
      pr_id: '57',
      callSetNodeObjPic: undefined,
      callback: continueFetchResolveAndPopModal,
    });


  }

  callRemoveScrollableModalWrapper(){

    if(!isAndroidTablet() || document.querySelector(`.scrollableModal`) === null) return;

    const scrollableModalWrapper =  document.querySelectorAll(`.scrollableModal`);
    if( typeof(scrollableModalWrapper) !== 'undefined' ) scrollableModalWrapper.forEach(el => el.remove());

  }

  callCreateScrollableModal(nameOfModal){

    if(!isAndroidTablet() ) return;

    this.callRemoveScrollableModalWrapper();

    const whenDomExist = () => {
      return document.querySelector(`#${nameOfModal}`) != null;
    }

    const makeScrollableBackgroundOverlay = () => {

      const elModalParentContainer = document.querySelector(`#${nameOfModal}`).parentElement;

      const elModalWidth = getComputedDomValue({element:  elModalParentContainer, cssProp: 'width'})
      // const elModalHeight = getComputedDomValue({element:  elModalParentContainer, cssProp: 'height'})
      elModalParentContainer.style.setProperty("position", 'relative');
      elModalParentContainer.style.setProperty("left", '0px');
      elModalParentContainer.style.setProperty("top", '0px');
      elModalParentContainer.style.setProperty("margin-top", `50px`);
      elModalParentContainer.style.setProperty("margin-left", `${ (window.innerWidth - elModalWidth)/2 }px`);
      elModalParentContainer.style.setProperty("margin-bottom", `2000px`);

      const idNameOfWrapper =`${nameOfModal}_wrapper`;
      wrap({toWrap: elModalParentContainer, idName: idNameOfWrapper});

      const elModalParentContainerWrapper = document.querySelector(`#${idNameOfWrapper}`);
      elModalParentContainerWrapper.style.setProperty("height", '100%');
      elModalParentContainerWrapper.style.setProperty("width", '100%');
      elModalParentContainerWrapper.style.setProperty("overflow", `scroll`);
      elModalParentContainerWrapper.style.setProperty("top", '0px');
      elModalParentContainerWrapper.style.setProperty("left", '0px');
      elModalParentContainerWrapper.style.setProperty("position", 'absolute');
      elModalParentContainerWrapper.style.setProperty("z-index", '9003');

      const nameOfScrollableModalWrapper = 'scrollableModal';
      elModalParentContainerWrapper.classList.add(nameOfScrollableModalWrapper);

    }

    doWhenReady({argument: '', condition: whenDomExist, callback: makeScrollableBackgroundOverlay, attempts: {ongoing:0, end: 99999999}, fromWhere: ''});

  }

  designateDesktopUploadDragOverTarget({mouseEvent}){

    const stageLeft =  Math.round(this.stage.current.position().x / this.stage.current.scaleX()) * -1;
    const stageTop =  (Math.round(this.stage.current.position().y / this.stage.current.scaleX()) * -1);
    const canvasTopDesktopMarginReal = this.props.canvasTop / this.stage.current.scaleX();

    const mouseX = mouseEvent.clientX;
    const mouseY = mouseEvent.clientY;

    const realMouseX = stageLeft + Math.round( mouseX/ this.stage.current.scaleX());
    const realMouseY = stageTop + Math.round( mouseY/ this.stage.current.scaleX());

    this.unhighlight();
    this.desktopUploadNode = undefined;
    for (let node in this.nodeObjsInViewPort) {

      const nodeTop = this.nodeObjs[node].top;
      const nodeRight = this.nodeObjs[node].right;
      const nodeBottom = this.nodeObjs[node].bottom;
      const nodeLeft = this.nodeObjs[node].left;

      if(
          parseInt(node, 10) > 0 &&
          realMouseX > nodeLeft &&
          realMouseX <  nodeRight &&
          realMouseY > nodeTop + canvasTopDesktopMarginReal &&
          realMouseY <  nodeBottom + canvasTopDesktopMarginReal
      ){

        this.desktopUploadNode = node;
        this.highlight(node, '');

      }

    };


  }

  enableMouseOverStageToFindDropTargetForMoveDropOnTarget(how){
    this.setState({
      activateDesignateDragOrDropTarget: how,
      moveMode: 'dragging',
    })
  }

  onCtrlBtnUp(){

    this.debugOrder++;
    this.debugObj['onCtrlBtnUp'] = {order: this.debugOrder}

    // this.showDebugLog('onCtrlBtnUp');

    // if(this.state.moveOperationWithCtrlKeyDnActivated) {
    this.cntrlDragNode = undefined;
    this.stageCanBeClickedTouchedHovered = true;
    if( this.props.floaters &&
        this.props.floaters.length > 0 &&
        !this.state.moveDecisionPanelVisible &&
        !this.dropOnGhostConfirming
      ){
      this.setShowFloaterPanel(true);
      this.redraw({});
    }
    this.setState({
      moveOperationWithCtrlKeyDnActivated: false,
      activateDesignateDragOrDropTarget: false,
    });
    this.enableMouseOverStageToFindDropTargetForMoveDropOnTarget(false)
    this.setDropOnNode(null);
    this.setCntrlDragNodeObj(null);
    this.enableStageDragging();
    this.destroyAtomNotification({which:'moveIsActive', fromWhere: 'cntlKey up'})
    // }
  }

  bindDesktopEvents(){

    if(dualPedigreeMode && !dualPedigreeLaunchOnDev ) return;

    /*
      if(!isMobilePhone() || !isMobileTablet()){
        var that = this;
        document.addEventListener( 'visibilitychange' , function() {
            if (document.hidden) {
                that.onCtrlBtnUp();
            } else {
                that.onCtrlBtnUp();
            }
        }, false );
      }
     */

    if(!isMobilePhone() || isMobileTablet()){

      /**
        *
        *
        * FOR MAKING DESKTOP MOUSEOVER PANNING BOXES TO APPEAR
        *
        *
        *
       */

      // this.stage.current.container().addEventListener('mousedown', (e) => {

      //   this.designateDragOrDropTarget({mouseEvent: e})

      // });






      // Drop file on Stage


      this.stage.current.container().addEventListener('dragenter', (e) => {
        this.nodeObjsInViewPort = this.gatherDropNodesWithinViewport({floatingPrId: '0', skipGhostNodes:true})
        e.preventDefault();
      })

      this.stage.current.container().addEventListener('dragover', (e) => {
        this.designateDesktopUploadDragOverTarget({mouseEvent: e})
        e.preventDefault();
      })

      this.stage.current.container().addEventListener('drop', (e) => {
        return; // Book Drop Photo on Node
        /*

        this.unhighlight();
        e.preventDefault();
        if( typeof(this.desktopUploadNode) === 'undefined' ){
          console.log('Nothing targeted');
          return;
        }

        // that.stage.setPointersPositions(e);
        this.dropChoiceMessageOpened = false;
        this.toggleDropChoiceMessage();

        // var that = this;

        if( isDevelopment ){
          console.log('Development');
          return;
        }

        const uploadFile = e.dataTransfer.items[0].getAsFile();

        const reader = new FileReader();
        reader.readAsDataURL(uploadFile);

        this.showProgressIndicator();

        const prId = this.nodeObjs[this.desktopUploadNode].prId;
        const node = this.nodeObjs[this.desktopUploadNode].n
        if( this.nodeObjs[node].img.type === 'real') window.removePhoto(prId);

        const uploadPhotoCallback = () =>{
          this.refetchProfiles([prId]);
          this.hideProgressIndicator()
        }

        this.props.uploadphoto({
          node,
          title: uploadFile.name,
          file: uploadFile,
          prId,
          uploadPhotoCallback,
        })
         */

/*
        reader.onload = function(f: any) {


          // const image = new Image();
          // const itemURL = image.src = f.target.result;
          // const file = itemURL.split(',')[1];

          Image.fromURL(itemURL, function (image) {
            this.layer.add(image);

            image.position(this.stage.getPointerPosition());
            image.draggable(true);

            this.layer.draw();
          });

        }
*/


/*
        var dt    = e.dataTransfer;
        var files = dt.files;
        for (var i = 0; i < files.length; i++) {
          var file = files[i];

          // file.addEventListener('loadend',(e, file) => {

          //     var bin           = this.result;
          //     console.log(`bin: `, bin);
          // });


          var reader = new FileReader();
          console.log(`file: `, file);
          reader.readAsDataURL(file);

        }

*/
      })



      this.stage.current.container().addEventListener('mousemove', (e) => {
        if(this.state.activateDesignateDragOrDropTarget) this.designateDragOrDropTarget({mouseEvent: e})
        if(this.mouseMoveDisabled) return;
        e.preventDefault();
        const mouseCursorY = e.clientY;
        const mouseCursorX = e.clientX;
        const screenXthatWillShowMouseOverRightBox = ( canvasSideMargin + this.props.canvasWidth ) - (mouseoverBoxWidth + canvasPadding);
        const screenXthatWillShowMouseOverLeftBox = canvasSideMargin + mouseoverBoxWidth + canvasPadding + (!this.state.flipPanelOpened ? 0 : flipPanelWidth );
        const screenYthatWillShowMouseOverTopBox = this.props.canvasTop + mouseoverBoxHeight + canvasPadding;
        const topScreenYEdgeOfCanvas = this.props.canvasTop + canvasPadding;
        this.screenYthatWillShowMouseOverBottomBox = this.navigationShiftUp + window.innerHeight - canvasBottomMargin - mouseoverBoxHeight - canvasPadding;
        const leftScreenXEdgeOfCanvas = canvasSideMargin + canvasPadding;
        const rightScreenXEdgeOfCanvas = this.props.canvasWidth - canvasPadding;
        this.bottomScreenYEdgeOfCanvas = this.navigationShiftUp + window.innerHeight - canvasBottomMargin - canvasPadding;

        if(mouseCursorY < screenYthatWillShowMouseOverTopBox && mouseCursorY > topScreenYEdgeOfCanvas){
          this.setMouseOverBoxDisplay('mouseOverTopBox', true);
        } else{
          this.setMouseOverBoxDisplay('mouseOverTopBox', false);
        }
        if(mouseCursorY > this.screenYthatWillShowMouseOverBottomBox && mouseCursorY < this.bottomScreenYEdgeOfCanvas){
          this.setMouseOverBoxDisplay('mouseOverBottomBox', true);
        } else{
          this.setMouseOverBoxDisplay('mouseOverBottomBox', false);
        }
        if(mouseCursorX < screenXthatWillShowMouseOverLeftBox && mouseCursorX > leftScreenXEdgeOfCanvas){
          this.setMouseOverBoxDisplay('mouseOverLeftBox', true);
        } else{
          this.setMouseOverBoxDisplay('mouseOverLeftBox', false);
        }
        if(mouseCursorX > screenXthatWillShowMouseOverRightBox &&  mouseCursorX < rightScreenXEdgeOfCanvas){
          this.setMouseOverBoxDisplay('mouseOverRightBox', true);
        } else{
          this.setMouseOverBoxDisplay('mouseOverRightBox', false);
        }

      });


      /**
        *
        *
        * SCROLL WHEEL ZOOM
        *
        *
        *
       */

      // const updateVerticalSliderZoom = () => {

      //   const sliderValue = this.stage.current.scaleX() * 10;
      //   this.setState({sliderValue})

      // }

      const updateInterval = 1000;

      const throttledUpdateVerticalSliderZoom = throttle(this.updateVerticalSliderZoom, updateInterval);

      this.stage.current.container().addEventListener('wheel', (e) => {

        // clearTimeout(this.clearingTimeOut);
        // this.clearingTimeOut = setTimeout(() => {
        //   this.isClearingCalledTooMuch()
        // }, 100);

        e.preventDefault();
        this.cleanUp({closePedigreeAddbox: true, skipMoveDecisionPanelVisible: true});
        this.unsetFirstTreeMatchCountNotify();
        this.unsetFirstRecordMatchCountNotify();
        const oldScale = this.stage.current.scaleX();
        const newScale = e.deltaY < 0 ? oldScale * 1.1 : oldScale / 1.1;

        const targetX = this.stage.current.getPointerPosition().x;
        const targetY = this.stage.current.getPointerPosition().y;

        const oldPos = {
          x: targetX / oldScale - this.stage.current.x() / oldScale,
          y: targetY / oldScale - this.stage.current.y() / oldScale,
        };

        if(newScale < minZoom || newScale > maxZoom) return;

        this.stage.current.scale({ x: newScale, y: newScale });
        const newPos = {
          x: -(oldPos.x - targetX / newScale) * newScale,
          y: -(oldPos.y - targetY / newScale) * newScale
        };

        this.stage.current.position(newPos);
        this.stage.current.batchDraw();
        this.calcNewStageCenterNodePos();

        // if(isInteger()){
        //   console.log('test XXX');
        //   const sliderValue = this.stage.current.scaleX() * 10;
        //   this.setState({sliderValue})
        // }
          // console.log(`this.stage.current.scaleX(): `, this.stage.current.scaleX());


        throttledUpdateVerticalSliderZoom();

        this.redraw({});

        clearTimeout(this.wheelScrollTimeOut);
        this.wheelScrollTimeOut = setTimeout(() => {
          this.hideMatchBubble();
        }, 100);

      });  // END SCROLL WHEEL ZOOM

      this.stage.current.on('dragstart', (event) => {

        this.mouseMoveDisabled = true;
        this.hideProductTour({fromWhere: 'UU', withLastStepNotify: true});
        if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();
        this.stageOriginX = event.target.x();
        this.stageOriginY = event.target.y();
        // this.state.moveDecisionPanelVisible && this.setMoveDecisionPanelVisible(false);
      });

      this.stage.current.on('dragmove', (event) => {

      });

      this.stage.current.on('dragend', (event)  => {
        this.mouseMoveDisabled = false;

        if(typeof( window.dragMiniMapContainer) !== 'undefined' ) {

          // const changeMainStageX = -1 * ( event.target.x() - this.stageOriginX ) * this.stage.current.scaleX();
          // const changeMainStageY = -1 * ( event.target.y() - this.stageOriginY ) /** this.stage.current.scaleX()*/;

        };

        /*
         ******************* Originally in dragstart
         */

        this.stageClickCanZoomStep = false;

        if( this.state.nodeShownInToolTip !== null ) this.hideToolTip();

        if( !this.state.showFloaterPanel &&
            !this.state.moveOperationWithCtrlKeyDnActivated &&
            this.props.floaters &&
            this.props.floaters.length > 0
        ){
          if(!minimal){
            this.setShowFloaterPanel(true);
          }
        }

        if(!this.state.moveOperationWithCtrlKeyDnActivated) this.destroyAtomNotification({all:true, fromWhere: 'stage dragstart'});

        this.unOpacityFloaters();
        if( this.state.showMoveHelp ) this.setShowMoveHelp(false);
        this.stopStageClickPropagation({fromWhere: 'dragstart'});
        this.unhighlight();
        this.hideNotificationModal({});
        if(this.props.isPedigree) this.setPedigreeAddbox({visible:false});

        /*
          ******************
         */

        this.calcNewStageCenterNodePos();
        this.redraw({});
        this.stopStageClickPropagation({fromWhere: 'dragend'});
        this.delayStageClickCanZoomStep();
      });


      /**
        *
        *
        * KEYPRESS EVENTS
        *
        *
        *
       */

      const body = document.querySelector('body');


      body.addEventListener('keydown', (e) => {

        this.visitedCount++; this.visited['keydown'] = this.visitedCount;

        if(!this.keyPressEnabled) return;
        const keypressed = e.which;
        const ctrlBtn = 17;
        const cmdBtn = 91;
        const enterBtn = 13;
        const esc = 27;

        this.debugOrder++;
        this.debugObj['keydown'] = {order: this.debugOrder, keypressed}

        const keyDnActions = () => {

            if( this.state.moveOperationWithCtrlKeyDnActivated ) return;

            this.debugOrder++;
            this.debugObj['keyDnActions'] = {order: this.debugOrder}

            // this.showDebugLog('keyDnActions');

            if(! this.state.moveOperationWithCtrlKeyDnActivated &&
                !this.state.flipPanelOpened ){

              this.toggleFlipPanel({close: true, from: 'keydown'});
              this.cleanUp({closePedigreeAddbox: true, skipDismissNotification: true})
              this.stageCanBeClickedTouchedHovered = false;
              this.setState({
                moveOperationWithCtrlKeyDnActivated: true,
                activateDesignateDragOrDropTarget: true,
              });
              this.setShowFloaterPanel(false);
              this.nodeObjsInViewPort = this.gatherDropNodesWithinViewport({floatingPrId: undefined});
              this.disableStageDragging();

              if(!this.decisionChoicesArray.length) this.buildChoicesArray();
              let description = 'Mouseover a node, then drag it over another node.';
              let message = 'You are now in Move mode.';
              if( typeof(window.trl) !== 'undefined' ) description = window.trl(description, 'hot key instruction')
              if( typeof(window.trl) !== 'undefined' ) message = window.trl(message, 'hot key instruction')

              const type = 'info';
              const duration = 0;
              const onClose = ()=>{
                console.log('Notification is closing');
              }

              this.notifyWithAtom({which:'moveIsActive', message, description, type, duration, onClose});
            }
        }

        switch(keypressed) {
          case ctrlBtn:
              keyDnActions();
            break;
          case cmdBtn:
              if(!isWindows()) keyDnActions();
            break;
          case enterBtn:
              if(dualPedigreeMode) e.preventDefault();
            break;
          default:
        }

        if (e.key === 'Escape' && e.shiftKey) {

           console.log(`%c StageCurrent Nulled`, [
             'color: white',
             'background: red',
             'font-size: 14px',
             'border: 5px solid red',
             'padding: 10px',
             ].join(';'));


            this.stage = null;
        }

      });

      body.addEventListener('keyup', (e) => {

        if(!this.keyPressEnabled) return;

        const keypressed = e.which;
        const keyup = 38;
        const keyright = 39;
        const keydown = 40;
        const keyleft = 37;
        const ctrlBtn = 17;
        const cmdBtn = 91;

        this.debugOrder++;
        this.debugObj['keyup'] = {order: this.debugOrder, keypressed}

        // this.showDebugLog('keyup');

        switch(keypressed) {
          case keyup:
            this.velocityMove('vertical', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)
            break;
          case keyright:
            this.velocityMove('horizontal', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)
            break;
          case keydown:
            this.velocityMove('vertical', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)
            break;
          case keyleft:
            this.velocityMove('horizontal', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)
            break;
          case ctrlBtn:
            this.onCtrlBtnUp();
            break;
          case cmdBtn:
            this.onCtrlBtnUp();
            break;
          default:
        }

        this.unOpacityFloaters();

      });


    } // END if !mobile


  }

  tooMuchVelocityRequest(){
    if(!this.velocityCanBeRequested){
      return true;
    } else{
      this.velocityCanBeRequested = false;
      setTimeout(() => {
        this.velocityCanBeRequested = true;
      }, 400);
      return false;
    }
  }

  pausePanHighlight = false;
  panAndHighlight({node, clickedImmediateFamily}){

      if(this.pausePanHighlight) return;
      this.pausePanHighlight = true;
      setTimeout(() => {
        this.pausePanHighlight = false;
      }, 1000);

      const nodeObjHasImmediateFam = (node)=>{
        return  typeof(this.nodeObjs[node]) !== 'undefined' &&
                typeof(this.nodeObjs[node].immediateFam) !== 'undefined'
      }

      const hightedlighedRefReady = (node) => {
        return typeof(this.refs) !== 'undefined' && typeof(this.refs[`node-${node}`]) !== 'undefined'
      }

      this.setFlipPanelOpenAfterAnimateComplete(false);

      const whenHightedlighedRefReadyCallback = () =>{

        this.highlight(node);
        const unhighlightCallback = () => {
          setTimeout(() => {
            this.unhighlight(node);
          }, 2000);
        }

        if( this.state.flipPanelOpened ) doWhenReady({argument: node, condition: nodeObjHasImmediateFam, callback: unhighlightCallback, attempts: {ongoing:0, end: 6}, fromWhere: 'nodeObjHasImmediateFam'})
        else unhighlightCallback();

      }

      doWhenReady({argument: node, condition: hightedlighedRefReady, callback: whenHightedlighedRefReadyCallback, attempts: {ongoing:0, end: 9999999}, fromWhere: 'hightedlighedRefReady'})
      if(!this.props.isPedigree) this.panAnimateToNode({ node, onlyPan: true, clickedImmediateFamily, skipScrollTo: false});

  }

  slidePanelTo2ndChooserInMoveDecisionPanel(){
    const decisionPanelExpanderDiv = document.getElementById('decisionPanelExpanderDiv')

    decisionPanelExpanderDiv.scrollBy({ // http://iamdustan.com/smoothscroll/
      left: 255,
      behavior: 'smooth'
    });

    document.querySelector('#decisionPanelExpanderDiv').classList.remove('expand-width');
  }

  updateMainState(){
    this.calcNewStageCenterNodePos()
    const curStageObj = this.getCurStagePos();
    this.currentStageX = curStageObj.x;
    this.currentStageY = curStageObj.y;
  }

  moveMainStage({x, y, cx, cy, skipUpdatePreviousTouchX}){

    //this.stage.current.move({x: x * this.stage.current.scaleX(), y: y * this.stage.current.scaleY()});

    const curStageObj = {
      x: this.currentStageX + -1 * (cx * this.stage.current.scaleX()),
      y: this.currentStageY + -1 * (cy * this.stage.current.scaleX()),
    };

    this.stage.current.position(curStageObj)
    this.stage.current.batchDraw();
    this.calcNewStageCenterNodePos();

    this.redraw({skipAdjustDragContainerPosition: true});
  }

  autoLaunchDecisionPanelAndClickChoose(){

    const addExistObj = { // move.js:293
      "floater_profile_id": "94315",
      "focusPrid": "6000000023252214790",
      "dropOnNode": "4",
      "dropOnPrId": "6000000023252214790",
      "floaterFirstName": "Fred",
      "floaterGender": "m",
      "node": "4"
    };

    this.setAddExistObj(addExistObj);
    this.setMoveDecisionPanelPos({ // move.js:267
      "left": 195.49999999999997,
      "top": 379.49999999999994
    })
    this.setMoveDecisionPanelVisible(true)

    setTimeout(() => {

      const afterFetch = ({ allPotentialParentPairs }) => {

        /*

          Must now unremark componentDidUpdate, line 43 of /Move/DecisionPanal/index.js

         */

      }
      this.props.fetchImmediateFamily({
        focusPrId: this.state.addExistObj.dropOnPrId,
        focusNodeId: this.state.addExistObj.dropOnNode,
        forWhat: 'siblingChooser',
        afterFetch,
      })

    }, 1000);
  }

  autoLaunchFlipPanel({node, callback}){

    const goToThisNode = ( typeof(node) === 'undefined' ? this.props.focusNode: node);
    this.onClickedNode(goToThisNode)
    this.setNodeForFlipFocus(goToThisNode);
    this.setFlipPanelOpen();
    if(typeof(callback) !== 'undefined'){
      callback();
    }
  }

  autoClickNavigation(){

    let direction = 'up';

    this.toggleNavigationalPanel({direction});
    this.setState({
      mapNavTabActive: true,
      allProfilesFetched: true,
    });

  }

  showModal({whichModalScreen}){
    this.hideNotificationModal({});
    this.setState({
      modalOpen : true,
      whichModalScreen,
    })
  }

  showDualPedigreeModal({node}){
    this.setState({
      cropNode: node,
      dualPedigreeModalOpen: true,
    })
  }

  showDualPedigreeModalChangeName({node, whichField}){
    this.setState({
      cropNode: node,
      dualPedigreeModalOpenChangeName: true,
      dualPedigreeModalOpenChangeWhichField: whichField,
    })
  }

  isSingleChildForDualPedigree({nodeObj}){
    if(!dualPedigreeMode) return;
    if( this.props.dualPedigreeObj.whichChildrenNode > 1 &&
        typeof(nodeObj.isChildrenOfDualPedFocusUnion) !== 'undefined' &&
        nodeObj.isChildrenOfDualPedFocusUnion &&
        this.props.dualPedigreeObj.whichChildrenNode === nodeObj.n
      ){
      return true;
    } else {
      return false;
    }
  }

  shouldHideChildrenForDualPedigree({nodeObj, branch}){

    if(!dualPedigreeMode) return;

    if(typeof(branch) !== 'undefined'){

      if( this.props.dualPedigreeObj.whichChildrenNode === -1 &&
        typeof(branch.isFocusRootCollar) !== 'undefined'  ){
        return true;
      }

    }

    if(typeof(nodeObj) !== 'undefined'){

      if( this.props.dualPedigreeObj.whichChildrenNode === -1 &&
          typeof(nodeObj.isChildrenOfDualPedFocusUnion) !== 'undefined' &&
          nodeObj.isChildrenOfDualPedFocusUnion
        ){
        return true;
      }

      if( this.props.dualPedigreeObj.whichChildrenNode > 1 &&
          typeof(nodeObj.isChildrenOfDualPedFocusUnion) !== 'undefined' &&
          nodeObj.isChildrenOfDualPedFocusUnion &&
          this.props.dualPedigreeObj.whichChildrenNode === nodeObj.n
        ){
        return false;
      }

      if( this.props.dualPedigreeObj.whichChildrenNode > 1 &&
          typeof(nodeObj.isChildrenOfDualPedFocusUnion) !== 'undefined' &&
          nodeObj.isChildrenOfDualPedFocusUnion &&
          this.props.dualPedigreeObj.whichChildrenNode !== nodeObj.n
        ){
        return true;
      }

    }

    /*
      if (this.props.dualPedigreeObj.whichChildrenNode === 0)  show all children
     */
    return false;

  }

  hideDualPedigreeModal({node,  submit}){
    this.setState({
      dualPedigreeModalOpen: false,
    })
    if( submit )this.refs[`node-${node}`].refLoadFrameWithSVGBlob();
  }

  hideDualPedigreeModalChangeName({node}){
    this.setState({
      dualPedigreeModalOpenChangeName: false,
    })
  }

  redrawDualPedigreeNode(node){
    this.refs[`node-${node}`].refLoadFrameWithSVGBlob();
  }

  resetDualPedigree_Render_HiRes_PrIdImgs(){
    this.dualPedigree_Render_HiRes_PrIdImgs.forEach( ( node ) => {
      this.refs[`node-${node}`].resetHiResImgLoaded();
    });
  }

  dualPedigree_Preview_LowRes_PrIdImgs = [];
  dualPedigree_Render_HiRes_PrIdImgs = [];
  countDualPedigreeImgLoaded({node, forPreview, forRender}){

    // const countOfRealPics = this.props.countOf.get('hasPics');
    // const countOf = this.props.countOf;

    if( typeof(forPreview) !== 'undefined' &&
        this.dualPedigree_Preview_LowRes_PrIdImgs.indexOf(node) < 0){
       this.dualPedigree_Preview_LowRes_PrIdImgs.push(node);
      // console.log('Adding: ', node);
      // console.log('=: ', this.props.nodeObjs[node].nm);
      // console.log('=: ', this.props.nodeObjs[node].img.src);
      // console.log(`Preview: `, JSON.stringify(this.dualPedigree_Preview_LowRes_PrIdImgs, null, 2));
      // console.log(`Node: `, node, '- Low length: ', this.dualPedigree_Preview_LowRes_PrIdImgs.length);
    }

    if( typeof(forRender) !== 'undefined' &&
        this.dualPedigree_Render_HiRes_PrIdImgs.indexOf(node) < 0){
       this.dualPedigree_Render_HiRes_PrIdImgs.push(node);
      // console.log('Adding: ', node);
      // console.log(`Render: `, JSON.stringify(this.dualPedigree_Render_HiRes_PrIdImgs, null, 2));
      // console.log(`Node: `, node, `- HiRes length: `, this.dualPedigree_Render_HiRes_PrIdImgs.length);
    }
  }

  pedigreeRender = true;
  breakDualPedigreeRender(){

    this.pedigreeRender = false;

    // const array1 = [
    //   { id: 0, name: 'john' },
    //   { id: 1, name: 'mary' },
    //   { id: 2, name: 'pablo' },
    //   { id: 3, name: 'escobar' }
    // ];

    // const array2 = [
    //   { id: 0, name: 'john' },
    //   { id: 1, name: 'mary' }
    // ];

    const array1 = this.dualPedigree_Preview_LowRes_PrIdImgs.map(node=>{
      return {id: node, name: this.props.nodeObjs[node].nm}
    });

    const array2 = this.dualPedigree_Render_HiRes_PrIdImgs.map(node=>{
      return {id: node, name: this.props.nodeObjs[node].nm}
    });

    console.log(`array1: `, JSON.stringify(array1, null, 2));
    console.log(`array2: `, JSON.stringify(array2, null, 2));

    const results = findDifference({array1, array2});

    console.log(`results: `, JSON.stringify(results, null, 2));

  }

  setHighResolutionImagesForDualPedigree(bool){

    // this.dualPedigree_Preview_LowRes_PrIdImgs.forEach((node)=>{
    //   this.refs[`node-${node}`].refLoadFrameWithSVGBlob();
    // })

    console.log('...setHighResolutionImagesForDualPedigree: ', bool);

    let setObj = {
      highResolutionImagesForDualPedigree: bool
    };

    this.setState(setObj);


    if( !bool ) return;

    this.dualPedigree_Render_HiRes_PrIdImgs = [];
    this.downloadingDualPedigreeChart = false;

    const highResDualPedigreeImgsAreDownloaded = () => {
      // console.log('lowRes:', this.dualPedigree_Preview_LowRes_PrIdImgs.length,' vs ', '  HiRes:',this.dualPedigree_Render_HiRes_PrIdImgs.length);
      return (this.dualPedigree_Preview_LowRes_PrIdImgs.length === this.dualPedigree_Render_HiRes_PrIdImgs.length || this.pedigreeRender === false);
    }

    const beginRenderStageCanvasToImgForDualPedigree = () => {

      // this.forceUpdateCanvas('dualPedigree render');
       setTimeout(() => {
          this.renderStageCanvasToImgForDualPedigree();
       }, 1000);

    }

    doWhenReady({argument: '', condition: highResDualPedigreeImgsAreDownloaded, callback: beginRenderStageCanvasToImgForDualPedigree, attempts: {ongoing:0, end: 999999}, fromWhere: 'setHighResolutionImagesForDualPedigree'})

  }

  downloadingDualPedigreeChart = false;
  renderStageCanvasToImgForDualPedigree(){

    if( this.downloadingDualPedigreeChart )  return;
    this.downloadingDualPedigreeChart = true;
    const stagePrint = this.stage.current.clone();
    let positionObj = undefined;
    let sizeObj = undefined;
    let scaleLarge = undefined;

    if( isMobileTablet()){

      scaleLarge = 1.9;
      positionObj = {x: 0, y: 60};
      sizeObj = {width: stagePedigreeSizeObj.width * 1.5, height: (stagePedigreeSizeObj.height + 20) * 1.5}
      stagePrint.scale({ x: scaleLarge, y: scaleLarge});

      let description = 'Log in on your desktop to download the Family Tree Chart at a higher resolution.';
      let message = 'Notice';
      if( typeof(window.trl) !== 'undefined' ) description = window.trl(description, 'Family tree chart notification for tablet')
      if( typeof(window.trl) !== 'undefined' ) message = window.trl(message, 'Family tree chart notification for tablet')
      const type = 'info';
      const position = 'bc';
      const duration = 10;
      const onOpen = () => {}
      const onClose = () => {}

      this.notifyWithAtom({which:'renderStageCanvasToImgForDualPedigree', description, message, type, position, duration, onOpen, onClose});

    } else {

      positionObj = {
        x: targetDualPedigreePosX + stagePrintDualPedigreeSizeObj.printShiftX,
        y: targetDualPedigreePosY + stagePrintDualPedigreeSizeObj.printShiftY
      }

      sizeObj = {width: stagePrintDualPedigreeSizeObj.width, height: stagePrintDualPedigreeSizeObj.height}
      scaleLarge = 10;

    }


    stagePrint.position(positionObj);
    stagePrint.size(sizeObj);

    stagePrint.scale({ x: scaleLarge, y: scaleLarge});

    this.downloadImageFileForPrint(stagePrint.toDataURL())

  }

  setStagePrintDownloadingTo(bool){

    this.setState({
      downloadingPedigreeChart: bool
    });

  }

  renderStageCanvasToImg(){
    window.alert('depreciated');
    this.printTreeComponent.current.stageCanvasPrint()
    return;

    if( this.state.downloadingPedigreeChart )  return;

    this.setState({
      downloadingPedigreeChart: true
    });

    if(this.props.chartType === 'fan') this.fanChartComponent.current.isPrint(true);

    setTimeout(() => {

      const stagePrint = this.stage.current.clone();

      const configHash = {
        'horizontal': {
          scale: 10,
          width: stagePrintPedigreeFanchartSizeObj.width,
          height: stagePrintPedigreeFanchartSizeObj.height,
        },
        'fan': {
          scale: 3.75,
          width: stagePrintPedigreeFanchartSizeObj.width,
          height: stagePrintPedigreeFanchartSizeObj.height,
        },
      }

      stagePrint.position({
        x: -50,
        y: this.props.chartType === 'fan' ? 200: 100
      });

      stagePrint.size({
        width: configHash[this.props.chartType].width - (this.props.chartType === 'fan' ? 300: 0),
        height: configHash[this.props.chartType].height
      });

      stagePrint.scale({
        x: configHash[this.props.chartType].scale,
        y: configHash[this.props.chartType].scale}
      );

      this.downloadPDFForPrint(stagePrint.toDataURL());

      this.setState({
        downloadingPedigreeChart: false
      });

      setTimeout(() => {
        if(this.props.chartType === 'fan') this.fanChartComponent.current.isPrint(false);
      }, 1000);

    }, 800);

  }

  downloadPDFForPrint(content){

    if( isDevelopment ){
      return;
    }

    const pageObj = {
      image: content,
      width: stagePedigreeSizeObj.width,
      height: stagePedigreeSizeObj.height,
      margin: [ 0, 0, 0, 0]
    }
    const docDefinition = {

      defaultStyle: {
        fontSize: 10,
        bold: false,
      },
      pageSize: 'letter',
      pageOrientation: 'landscape',
      content: cloneDeep([pageObj]),
      };

    if(isIE() ){
      pdfMake.createPdf(docDefinition).download();
      return;
    }
    pdfMake.createPdf(docDefinition).open();

    this.setState({
      downloadingPedigreeChart: false
    });

  }

  downloadImageFileForPrint(content){

    // if( dualPedigreeLaunchOnDev ){
    //   this.hideProgressIndicator();
    //   this.setHighResolutionImagesForDualPedigree(false);
    //   this.resetDualPedigree_Render_HiRes_PrIdImgs()
    //   return;
    // }

    content = content.replace(/^data:image\/\w+;base64,/, '');
    var link = document.createElement('a');
    link.style = 'position: fixed; left -10000px;';
    // link.href = `data:application/octet-stream;base64,${encodeURIComponent(content)}`;
    link.href = `data:application/octet-stream;base64,${encodeURIComponent(content)}`;
    // link.download = /\.\w+/.test('DualpedigreeChart') ? 'DualpedigreeChart' : `${'DualpedigreeChart'}.${'jpg'}`;
    link.download = `${decodeURIComponent(decodeURI(this.props.dualPedigreeObj.titleName))}.${'jpg'}`;

    setTimeout(() => {

      // document.getElementById("debugDiv2").innerHTML += `${content}`;
      this.hideProgressIndicator();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadingDualPedigreeChart = false;
      this.setHighResolutionImagesForDualPedigree(false);
      this.resetDualPedigree_Render_HiRes_PrIdImgs()
    }, 1000);

  }

  hideModal(){
    this.setState({
      modalOpen: false,
      whichModalScreen: null,
    })
  }

  autoLaunchPedigreeCallout(){

    this.setPedigreeAddbox({
      "left": 779.6999999999999,
      "top": 327.75,
      "visible": true,
      "node": "20"
    })

    // setTimeout(() => {
    //   this.autoLaunchFlipPanel(20);
    // }, 1000);

  }

  getRenderDualPedigreeCenterResizePicModal(){

    return (

        <DualPedigreeCenterResizePicModal
          dualPedigreeModalOpen={this.state.dualPedigreeModalOpen}
          translatedLabels={this.translatedLabels}
          hideDualPedigreeModal={this.hideDualPedigreeModal.bind(this)}
          nodeObjs={this.nodeObjs}
          cropNode={this.state.cropNode}
          dualPedigreeBackgroundTextureFileName={this.state.dualPedigreeBackgroundTextureFileName}
          postPoster={this.props.postPoster}
          dualPedigreeObj={this.props.dualPedigreeObj}
          focusPrId={this.props.dualPedigreeObj.focusPrId}
        />
    )
  }


  getRenderResolve(){

    const prId = this.props.nodeObjs[(this.props.chartType === 'fan' ? this.props.fanChartData.node.n: this.props.focusNode)].pr_id;

    return (

          <Resolve
            maleCustomColor={this.state.maleCustomColor}
            femaleCustomColor={this.state.femaleCustomColor}
            unGenderedCustomColor={this.state.unGenderedCustomColor}
            showProgressIndicator={this.showProgressIndicator.bind(this)}
            toggleFlipPanel={this.toggleFlipPanel.bind(this)}
            canvasHeight={this.props.canvasHeight}
            resolve={this.props.resolve}
            resolvePrId={this.state.resolvePrId}
            nodeObjs={this.props.nodeObjs}
            postResolve={this.props.postResolve}
            fetchImmediateFamily={this.props.fetchImmediateFamily}
            setResolveVisible={this.setResolveVisible.bind(this)}
            focusPrid={prId}
            reloadCanvasTree={this.reloadCanvasTree.bind(this)}
            callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
            translatedLabels={this.translatedLabels}
          />
    )
  }

  getRenderDualPedigreeChangeNameModal(){

    return (

        <DualPedigreeChangeNameModal
          dualPedigreeModalOpenChangeName={this.state.dualPedigreeModalOpenChangeName}
          dualPedigreeModalOpenChangeWhichField={this.state.dualPedigreeModalOpenChangeWhichField}
          translatedLabels={this.translatedLabels}
          hideDualPedigreeModalChangeName={this.hideDualPedigreeModalChangeName.bind(this)}
          nodeObjs={this.nodeObjs}
          cropNode={this.state.cropNode}
          postPoster={this.props.postPoster}
          dualPedigreeObj={this.props.dualPedigreeObj}
          focusPrId={this.props.dualPedigreeObj.focusPrId}
        />
    )
  }

  getRenderMoveDecisionPanel(){

    return (
      <MoveDecisionPanel
        canvasWidth={this.props.canvasWidth}
        canvasHeight={this.props.canvasHeight}
        canvasTop={this.props.canvasTop}
        postAddExisting={this.props.postAddExisting}
        fetchProfiles={this.props.fetchProfiles}
        fetchImmediateFamily={this.props.fetchImmediateFamily}
        unions={this.unions}
        nodeObjs={this.props.nodeObjs}
        lookUpPrId={this.props.lookUpPrId}
        lookUpNodeId={this.props.lookUpNodeId}
        addExistObj={this.state.addExistObj}
        decisionChoicesArray={this.decisionChoicesArray}
        stage={this.stage}
        setMoveDecisionPanelVisible={this.setMoveDecisionPanelVisible.bind(this)}
        slidePanelTo2ndChooserInMoveDecisionPanel={this.slidePanelTo2ndChooserInMoveDecisionPanel.bind(this)}
        postToServer={this.postToServer.bind(this)}
        callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
        destroyAtomNotification={this.destroyAtomNotification.bind(this)}
        cleanUp={this.cleanUp.bind(this)}
        setShowFloaterPanel={this.setShowFloaterPanel.bind(this)}
        unhighlight={this.unhighlight.bind(this)}
        translatedLabels={this.translatedLabels}
        floaters={this.props.floaters}
        moveDecisionPanelPos={this.state.moveDecisionPanelPos}/>
    )
  }

  getRenderFloaterPanel(){
    return (

      <FloaterPanel
        triggerFloaterMoveDecisionPanel={this.triggerFloaterMoveDecisionPanel.bind(this)}
        chartType={this.props.chartType}
        focusNode={ this.props.chartType === 'fan' ? this.props.fanChartData.node.n: this.props.focusNode}
        fanchartCurrent={this.fanChartComponent.current}
        setCntrlDragNodeObj={this.setCntrlDragNodeObj.bind(this)}
        launchMoveDecisonPanel={this.launchMoveDecisonPanel.bind(this)}


        isPedigree={this.props.isPedigree}
        setFlipCardScreenIsOn={this.setFlipCardScreenIsOn.bind(this)}
        showMobileFlipCard={this.showMobileFlipCard.bind(this)}
        toggleFlipPanel={this.toggleFlipPanel.bind(this)}
        setMoveDecisionPanelVisible={this.setMoveDecisionPanelVisible.bind(this)}
        setShowFloaterPanel={this.setShowFloaterPanel.bind(this)}
        highlight={this.highlight.bind(this)}
        unhighlight={this.unhighlight.bind(this)}
        canvasTop={this.props.canvasTop}
        canvasWidth={this.props.canvasWidth}
        canvasHeight={this.props.canvasHeight}
        stage={this.stage}
        nodeObjs={this.props.nodeObjs}
        unions={this.unions}
        nodeObjsInViewPort={this.nodeObjsInViewPort}
        gatherDropNodesWithinViewport={this.gatherDropNodesWithinViewport.bind(this)}
        setMoveDecisionPanelPos={this.setMoveDecisionPanelPos.bind(this)}
        designateDragOrDropTarget={this.designateDragOrDropTarget.bind(this)}
        setAddExistObj={this.setAddExistObj.bind(this)}
        postAddExisting={this.props.postAddExisting}
        removeFloater={this.props.removeFloater}
        floaters={this.props.floaters}
        redraw={this.redraw.bind(this)}
        confirmDropOnGhost={this.confirmDropOnGhost.bind(this)}
        callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
        setMoveHelpPos={this.setMoveHelpPos.bind(this)}
        destroyAtomNotification={this.destroyAtomNotification.bind(this)}
        setShowMoveHelp={this.setShowMoveHelp.bind(this)}
        showMoveHelp={this.state.showMoveHelp}
        cleanUp={this.cleanUp.bind(this)}
        setIsDraggingFloater={this.setIsDraggingFloater.bind(this)}
        translatedLabels={this.translatedLabels}
        ieAddedScrollBarWidthFloaters={this.ieAddedScrollBarWidthFloaters}
      />
    )
  }
  getRenderFlipPanelDesktop(){

        const {
          canvasTop,
          canvasWidth,
          flipData,
          isPedigree,
        } = this.props;

        let {
          canvasHeight,
        } = this.props;

        const props = {
          flipData,
          canvasWidth,
          canvasHeight,
          canvasTop,
          assets,
          isPedigree,
        };

        return (

        <Flippanel
          ref="flippanelComponent"
          {...props}
          postInvite={this.props.postInvite}
          navigationPanelIsUp={this.state.navigationPanelIsUp}

          canChangeDifferentParent={this.canChangeDifferentParent.bind(this)}
          canShowPendingMerge={this.canShowPendingMerge.bind(this)}
          canShowInconsistency={this.canShowInconsistency.bind(this)}
          canShowResolveWarning={this.canShowResolveWarning.bind(this)}
          canShowCycleCount={this.canShowCycleCount.bind(this)}
          hasGedcom={this.hasGedcom.bind(this)}
          hasDna={this.hasDna.bind(this)}

          showHookMessageForNearbyTreeMatches={this.showHookMessageForNearbyTreeMatches.bind(this)}
          showHookMessageNeedForReload={this.showHookMessageNeedForReload.bind(this)}
          clickforImmediateFamily={this.clickforImmediateFamily.bind(this)}
          isPedigree={this.props.isPedigree}
          chartType={this.props.chartType}
          cidsGrps={this.props.cidsGrps}
          flipNodeCrumbs={this.state.flipNodeCrumbs}
          openAddNodeForm={this.openAddNodeForm.bind(this)}
          panAnimateToNode={this.panAnimateToNode.bind(this)}
          callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
          setFlipPanelOpenAfterAnimateComplete={this.setFlipPanelOpenAfterAnimateComplete.bind(this)}
          toggleFlipPanel={this.toggleFlipPanel.bind(this)}
          setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
          addNodeFormFocus={this.state.nodeForFlipFocus}
          nodeObjs={this.props.nodeObjs}
          fetchResolveAndPopModal={this.fetchResolveAndPopModal.bind(this)}
          setPedigreeAddbox={this.setPedigreeAddbox.bind(this)}
          buildChoicesArray={this.buildChoicesArray.bind(this)}
          decisionChoicesArray={this.decisionChoicesArray}
          reloadWithNewTree={this.reloadWithNewTree.bind(this)}
          refocusFanChart={this.refocusFanChart.bind(this)}
          onclickedAddNodeTab={this.onclickedAddNodeTab.bind(this)}
          setPushToHistory={this.setPushToHistory.bind(this)}
          fetchFlipMoreFilter={this.props.fetchFlipMoreFilter}
          setMouseOverBoxDisplay={this.setMouseOverBoxDisplay.bind(this)}
          notifyWithAtom={this.notifyWithAtom.bind(this)}
          stopStageClickPropagation={this.stopStageClickPropagation.bind(this)}
          nodeIsDeadPerson={this.nodeIsDeadPerson.bind(this)}
          nodeIsPresumedDeadPerson={this.nodeIsPresumedDeadPerson.bind(this)}
          showTreeOverlay={this.showTreeOverlay.bind(this)}
          nodeForFlipFocus={this.state.nodeForFlipFocus}
          focusNode={this.props.focusNode}
          flipPanelOpened={this.state.flipPanelOpened}
          translatedLabels={this.translatedLabels}
          setNodeObjPic={this.props.setNodeObjPic}
          postChosenUnionId={this.props.postChosenUnionId}
          setShowFloaterPanel={this.setShowFloaterPanel.bind(this)}
          redraw={this.redraw.bind(this)}
          addFloater={this.addFloater.bind(this)}
          showProgressIndicator={this.showProgressIndicator.bind(this)}
          hideNotificationModal={this.hideNotificationModal.bind(this)}
          hideProductTour={this.hideProductTour.bind(this)}

        />

      )


  }

  getRenderNavigation(){

   if( dualPedigreeMode) return null;

    const {
      canvasWidth,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    const scaleX = this.stage.current.scaleX();

    return (

        <Navigation
          maleCustomColor={this.state.maleCustomColor}
          femaleCustomColor={this.state.femaleCustomColor}
          unGenderedCustomColor={this.state.unGenderedCustomColor}
          nodeObjs={this.nodeObjs}
          unions={this.unions}
          focusNode={this.props.focusNode}
          isLargeTree={this.props.isLargeTree}
          progress={this.props.progress}
          mainCanvasScale={scaleX}
          viewPortSides={this.props.viewPortSides}
          refreshGotoList={this.state.refreshGotoList}
          allProfilesFetched={this.state.allProfilesFetched}
          navigationPanelIsUp={this.state.navigationPanelIsUp}
          getEdgeOfTree={this.getEdgeOfTree.bind(this)}
          setGotoNavTabActive={this.setGotoNavTabActive.bind(this)}
          fetchEveryProfile={this.fetchEveryProfile.bind(this)}
          gotoMainStagePos={this.gotoMainStagePos.bind(this)}
          hideNotificationModal={this.hideNotificationModal.bind(this)}
          gotoNavTabActive={this.state.gotoNavTabActive}
          setMapNavTabActive={this.setMapNavTabActive.bind(this)}
          mapNavTabActive={this.state.mapNavTabActive}
          preferences={this.props.preferences}
          prepareGotoNavData={this.prepareGotoNavData.bind(this)}
          flipPanelOpened={this.state.flipPanelOpened}
          canvasWidth={canvasWidth}
          canvasHeight={canvasHeight}
          toggleNavigationalPanel={this.toggleNavigationalPanel.bind(this)}
          translateUsingLn={this.translateUsingLn.bind(this)}
          translateUsingMdn={this.translateUsingMdn.bind(this)}
          moveMainStage={this.moveMainStage.bind(this)}
          updateMainState={this.updateMainState.bind(this)}
          loadFlip={this.loadFlip.bind(this)}
          changeFlipNodeCrumbs={this.changeFlipNodeCrumbs.bind(this)}
          panAndHighlight={this.panAndHighlight.bind(this)}
        />
    )
  }


  getPedigreeAddBoxCallout(){

    const {
      canvasWidth,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    return (
                <Fragment>
                  <Addbox
                    immediateFamVersion={'addbox'}
                    canvasHeight={canvasHeight}
                    canvasWidth={canvasWidth}
                    clickforImmediateFamily={this.clickforImmediateFamily.bind(this)}
                    setPedigreeAddbox={this.setPedigreeAddbox.bind(this)}
                    fetchImmediateFamily={this.props.fetchImmediateFamily}
                    toggleFlipPanel={this.toggleFlipPanel.bind(this)}
                    setNodeForFlipFocus={this.setNodeForFlipFocus.bind(this)}
                    hidePedigreeAddbox={this.hidePedigreeAddbox.bind(this)}
                    openAddNodeForm={this.openAddNodeForm.bind(this)}
                    stopStageClickPropagation={this.stopStageClickPropagation.bind(this)}
                    onClickEdit={this.onClickEdit.bind(this)}
                    reloadCanvasTree={this.reloadCanvasTree.bind(this)}
                    refocusFanChart={this.refocusFanChart.bind(this)}
                    chartType={this.props.chartType}
                    pedigreeAddboxLeft={this.state.pedigreeAddboxLeft}
                    pedigreeAddboxTop={this.state.pedigreeAddboxTop}
                    addNodeFormFocus={this.state.pedigreeAddboxNode}
                    flipPanelOpened={this.state.flipPanelOpened}
                    nodeObjs={this.props.nodeObjs}
                    nodeObj={this.props.nodeObjs[this.state.pedigreeAddboxNode]}
                    scaleX={this.stage.current.scaleX()}
                  />
                  <CalloutTriTip
                    scaleX={this.stage.current.scaleX()}
                    flipPanelOpened={this.state.flipPanelOpened}
                    pedigreeAddboxLeft={this.state.pedigreeAddboxLeft}
                    pedigreeAddboxTop={this.state.pedigreeAddboxTop}
                    whichSideTip={this.state.whichSideTip}
                  />
                </Fragment>

    )
  }


  getRenderMoveHelp(){

    return (

      <MoveHelp
        canvasTop={this.props.canvasTop}
        setShowMoveHelp={this.setShowMoveHelp.bind(this)}
        translatedLabels={this.translatedLabels}
        moveHelpPos={this.state.moveHelpPos}
        ieAddedScrollBarWidthFloaters={this.ieAddedScrollBarWidthFloaters}
        floaters={this.props.floaters}
      />

    )
  }


  getRenderInviteModal(){

    return (

      <InviteModal
              callHookForMessageAlert={this.callHookForMessageAlert.bind(this)}
              notifyWithAtom={this.notifyWithAtom.bind(this)}
              hideInviteModal={this.hideInviteModal.bind(this)}
              setCanHideInviteModal={this.setCanHideInviteModal.bind(this)}
              postInvite={this.props.postInvite}
              invitePrId={this.state.invitePrId}
              inviteNode={this.state.inviteNode}
              inviteFullName={this.state.inviteFullName}
              translatedLabels={this.translatedLabels}
              isPedigree={this.props.isPedigree}
              nodeObjs={this.nodeObjs}
      />

    )
  }

  getRenderPreferencesDesktop(){

    return (

      <PreferencesDesktop
        chartType={this.props.chartType}
        isPedigree={this.props.isPedigree}
        modalOpen={this.state.modalOpen}
        nodeObjs={this.nodeObjs}
        nodeForFlipFocus={this.state.nodeForFlipFocus}
        whichModalScreen={this.state.whichModalScreen}
        hideModal={this.hideModal.bind(this)}
        setCustomColors={this.setCustomColors.bind(this)}
        setCustomStylesForTree={this.setCustomStylesForTree.bind(this)}
        setOptionsForTree={this.setOptionsForTree.bind(this)}
        resetToDefaultColors={this.resetToDefaultColors.bind(this)}
        postPreferences={this.props.postPreferences}
        fetchPreferences={this.props.fetchPreferences}
        preferences={this.props.preferences}
        translatedLabels={this.translatedLabels}
        fontSizeChoice={this.state.fontSizeChoice}
        selectedtheme={this.state.selectedtheme}
        maleCustomColor={this.state.maleCustomColor}
        femaleCustomColor={this.state.femaleCustomColor}
        unGenderedCustomColor={this.state.unGenderedCustomColor}
        stageBackgroundCustomColor={this.state.stageBackgroundCustomColor}
        presetCustomObj={this.state.presetCustomObj}

        showCardPhotos={this.state.showCardPhotos}
        showCardEditIcon={this.state.showCardEditIcon}
        showCardEmailInvite={this.state.showCardEmailInvite}

        cacheBreakPics={this.state.cacheBreakPics}
        placeholderImage_m={this.state.placeholderImage_m}
        placeholderImage_f={this.state.placeholderImage_f}
        placeholderImage_u={this.state.placeholderImage_u}
      />


    )
  }

  getLegendDesktop(){

    if( !this.state.showLegendModal ) return null;

    return (

      <Legend
        chartType={this.props.chartType}
        modalOpen={this.state.modalOpen}
        nodeObjs={this.nodeObjs}
        nodeForFlipFocus={this.state.nodeForFlipFocus}
        setShowLegendModal={this.setShowLegendModal.bind(this)}
        toggleProductTour={this.toggleProductTour.bind(this)}
        translatedLabels={this.translatedLabels}
        fontSizeChoice={this.state.fontSizeChoice}
        legendDescriptions={this.props.legendDescriptions}
        placeholderImage_m={this.state.placeholderImage_m}
        placeholderImage_f={this.state.placeholderImage_f}
        placeholderImage_u={this.state.placeholderImage_u}
        fetchLegendDescriptions={this.props.fetchLegendDescriptions}
        focusPrId={this.props.focusPrId}
      />


    )
  }


  getRenderDesktopControlComponents(){

    const showCornerMessage = () => {
      return typeof(this.props.preferences) !== 'undefined' && this.props.preferences.get('show_ancestors') && !this.props.isPedigree && typeof(this.nodeObjs) !== 'undefined' && typeof(this.stage) !== 'undefined'
    }

    const mouseOverTopBoxStyle = {
      top: `${ canvasPadding }px`,
      left: `${ (window.innerWidth / 2) - ( mouseoverBoxWidth / 2 ) }px`,
      backgroundImage: `url(${imageBasePath}up.svg)`,
      'backgroundColor': '#c0c0bf !important',
    };
    const mouseOverBottomBoxStyle = {
      top: `${ this.props.canvasHeight - ( canvasBottomMargin + mouseoverBoxHeight + canvasPadding ) }px`,
      left: `${ (window.innerWidth / 2) - ( mouseoverBoxWidth / 2 ) }px`,
      backgroundImage: `url(${imageBasePath}down.svg)`,
      'backgroundColor': '#c0c0bf !important',
    };
    const mouseOverRightBoxStyle = {
      top: `${(this.props.canvasHeight / 2) - ( canvasBottomMargin + mouseoverBoxHeight / 2)}px`,
      left: `${(this.props.canvasWidth - (canvasBottomMargin + mouseoverBoxWidth + canvasPadding))}px`,
      backgroundImage: `url(${imageBasePath}right.svg)`,
      'backgroundColor': '#c0c0bf !important',
    };
    const mouseOverLeftBoxStyle = {
      top: `${(this.props.canvasHeight / 2) - ( canvasBottomMargin + mouseoverBoxHeight / 2)}px`,
      left: `${canvasSideMargin + canvasPadding }px`,
      backgroundImage: `url(${imageBasePath}left.svg)`,
      'backgroundColor': '#c0c0bf !important',
    };

    const {
      canvasTop,
      canvasWidth,
      flipData,
      isPedigree,
      isFanChart,
      chartType,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    // if(isMobilePhone()) canvasHeight += 10;

    const props = {
      flipData,
      canvasWidth,
      canvasHeight,
      canvasTop,
      assets,
      isPedigree,
      isFanChart,
      chartType,
    };

    // document.getElementById("debugDiv5").innerHTML = `this.props.isPedigree: ${this.props.isPedigree}:`;
    // document.getElementById("debugDiv4").innerHTML = `isMobileTablet(): ${isMobileTablet()}:`;

    return (

        <div>
          <Pan
              {...props}
              focusNodeObj={this.props.focusNodeObj}
              isPedigree={this.props.isPedigree}
              // focusProfileImgUrl={this.focusProfileImgUrl}
              onClickedNode={this.onClickedNode.bind(this)}
              velocityMove={this.velocityMove.bind(this)}
              gotoFocusNode={this.gotoFocusNode.bind(this)}
              cleanUp={this.cleanUp.bind(this)}
              hideProductTour={this.hideProductTour.bind(this)}
              zoomAnimateCenterPedigree={this.zoomAnimateCenterPedigree.bind(this)}
              gotoFanChartCenter={this.gotoFanChartCenter.bind(this)}
              panAnimateCenterPedigree={this.panAnimateCenterPedigree.bind(this)}
          />

          {

            minimal ?

            null

            :

              <Fragment>


                {

                  !isMobileTablet()

                  ?

                      <VerticalSlider
                        {...props}
                        scaleX={( isMobilePhone() || typeof(this.stage.current.scaleX()) === 'undefined' ? undefined: this.stage.current.scaleX())}
                        sliderValue={this.state.sliderValue}
                        chartType={this.props.chartType}
                        desktopVerticalSliderZoom={this.desktopVerticalSliderZoom.bind(this)}
                        desktopVerticalSliderStart={this.desktopVerticalSliderStart.bind(this)}
                        desktopVerticalSliderStop={this.desktopVerticalSliderStop.bind(this)}
                      />
                   :

                    null
                }


                {

                  ( this.props.chartType !== 'fan'  && this.state.treeIsVisable && !minimal)

                  ?


                      <HelpIcon
                        {...props}
                        setShowLegendModal={this.setShowLegendModal.bind(this)}
                        gotoFocusNode={this.gotoFocusNode.bind(this)}
                        hideMatchBubble={this.hideMatchBubble.bind(this)}
                        toggleProductTour={this.toggleProductTour.bind(this)}
                      />

                   :

                    null
                }

                <Config
                    {...props}
                    hideProductTour={this.hideProductTour.bind(this)}
                    showModal={this.showModal.bind(this)}
                />
{/*
                  (!this.props.isPedigree && showPrintTree === 'true' && !this.state.showProgressIndicator) ||
                  (!this.props.isPedigree && isDevelopment)


                  ( isSeinfeld && showPrintTree === 'true' && !this.state.showProgressIndicator ) ||
                  ( urlGet('test') === "true" && showPrintTree === 'true' && !this.state.showProgressIndicator ) ||
                  ( isDevelopment) ||
                  ( !this.props.isPedigree && showPrintTree === 'true' && !this.state.showProgressIndicator)

*/}


                {

                  (showPrintTree === 'true' && !this.state.showProgressIndicator) || isDevelopment

                    ?

                            isMobileTablet()  &&
                             this.props.isPedigree

                              ?

                                null

                              :

                                <PrintTreeIcon
                                    {...props}
                                    showProgressIndicator={this.showProgressIndicator.bind(this)}
                                    setPrintModalVisible={this.setPrintModalVisible.bind(this)}
                                    setHighResolutionImagesForDualPedigree={this.setHighResolutionImagesForDualPedigree.bind(this)}
                                    renderStageCanvasToImgForDualPedigree={this.renderStageCanvasToImgForDualPedigree.bind(this)}
                                    hideProductTour={this.hideProductTour.bind(this)}
                                    clearImgCache={this.state.clearImgCache}
                                    isDualPedigree={this.props.isDualPedigree}
                                />


                  :

                  null
                }


                {
                  !this.state.showProgressIndicator  && !dualPedigreeMode

                     ?


                      <SwitchTree
                          {...props}
                          switchTree={this.switchTree.bind(this)}
                          switchTreeTo={this.switchTreeTo.bind(this)}
                          setShowSwitchOtherIcons={this.setShowSwitchOtherIcons.bind(this)}
                          toggleNavigationalPanel={this.toggleNavigationalPanel.bind(this)}
                          isPedigreeDev={this.state.isPedigreeDev}
                          maxAncestorGen={this.props.maxAncestorGen}
                          showSwitchOtherIcons={this.state.showSwitchOtherIcons}
                          clearImgCache={this.state.clearImgCache}
                      />

                     :

                     null
                }

                {
                    showCornerMessage()

                  ?
                      <CornerMessage
                         postPreferences={this.props.postPreferences}
                        {...props}
                      />

                  :
                      null

                }

              </Fragment>

          }

          <div id="mouseOverBoxWrapper">
            <div id="mouseOverTopBox" ref="mouseOverTopBox" style={mouseOverTopBoxStyle}  className="mouseoverBox box hidden"  onClick={()=>{this.velocityMove('vertical', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}} >
            </div>
            <div id="mouseOverRightBox" ref="mouseOverRightBox" style={mouseOverRightBoxStyle}  className="mouseoverBox box hidden"  onClick={()=>{this.velocityMove('horizontal', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}}>
            </div>
            <div id="mouseOverBottomBox" ref="mouseOverBottomBox" style={mouseOverBottomBoxStyle}  className="mouseoverBox box hidden"   onClick={()=>{this.velocityMove('vertical', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}}>
            </div>
            <div id="mouseOverLeftBox" ref="mouseOverLeftBox" style={mouseOverLeftBoxStyle}  className="mouseoverBox box hidden" onClick={()=>{this.velocityMove('horizontal', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}} >
            </div>
          </div>

        </div>

    )
  }

  getDualPedigreeDownloadIcon(){

    const {
      canvasTop,
      canvasWidth,
      isPedigree,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    const props = {
      canvasWidth,
      canvasHeight,
      canvasTop,
      isPedigree,
    };

    return(
      <PrintTreeIcon
          {...props}
          showProgressIndicator={this.showProgressIndicator.bind(this)}
          setPrintModalVisible={this.setPrintModalVisible.bind(this)}
          setHighResolutionImagesForDualPedigree={this.setHighResolutionImagesForDualPedigree.bind(this)}
          renderStageCanvasToImgForDualPedigree={this.renderStageCanvasToImgForDualPedigree.bind(this)}
          hideProductTour={this.hideProductTour.bind(this)}
          clearImgCache={this.state.clearImgCache}
          isDualPedigree={this.props.isDualPedigree}
      />
    )


  }

  getRenderDualPedigreePanel(){

    const {
      canvasTop,
      canvasWidth,
      flipData,
      isPedigree,
    } = this.props;

    let {
      canvasHeight,
    } = this.props;

    // if(isMobilePhone()) canvasHeight += 10;

    const props = {
      flipData,
      canvasWidth,
      canvasHeight,
      canvasTop,
      assets,
      isPedigree,
    };

    return (

        <DualPedigreePanel
          {...props}
          progressIndicatorIs={this.state.showProgressIndicator}
          showProgressIndicator={this.showProgressIndicator.bind(this)}
          hideProgressIndicator={this.hideProgressIndicator.bind(this)}
          height={this.props.canvasHeight}
          clearImgCache={this.state.clearImgCache}
          canvasTop={this.props.canvasTop}
          postPoster={this.props.postPoster}
          fetchTree={this.props.fetchTree}
          setPrId={this.props.setPrId}
          reloadCanvasTree={this.reloadCanvasTree.bind(this)}
          redraw={this.redraw.bind(this)}
          dualPedigreePanelTabOn={this.state.dualPedigreePanelTabOn}
          dualPedigreeCollapseChoice={this.state.dualPedigreeCollapseChoice}
          dualPedigreeBackgroundTextureFileName={this.state.dualPedigreeBackgroundTextureFileName}
          chooseFrameTypeDualPedigree={this.chooseFrameTypeDualPedigree.bind(this)}
          chooseBackgroundTextureDualPedigree={this.chooseBackgroundTextureDualPedigree.bind(this)}
          includeDate={this.includeDate.bind(this)}
          showWhichChildren={this.showWhichChildren.bind(this)}
          chooseTitleBorderDualPedigree={this.chooseTitleBorderDualPedigree.bind(this)}
          chooseFontFamilyDualPedigree={this.chooseFontFamilyDualPedigree.bind(this)}
          setDualPedigreePanelChoices={this.setDualPedigreePanelChoices.bind(this)}
          dualPedigreeObj={( !dualPedigreeLaunchOnDev ? this.props.dualPedigreeObj: undefined)}
          unions={this.props.unions}
          nodeObjs={this.nodeObjs}
          isPedigree={this.props.isPedigree}
          focusPrid={(!dualPedigreeLaunchOnDev && typeof(this.props.nodeObjs) !== 'undefined'  ? this.props.nodeObjs[this.props.focusNode].pr_id: undefined)}
        />
    )
  }

  getRenderPrintModalDesktop(){

    return (

       <PrintModalDesktopWithDualPedigreeOption
          clearImgCache={this.state.clearImgCache}
          placeholderImage_m={this.state.placeholderImage_m}
          placeholderImage_f={this.state.placeholderImage_f}
          placeholderImage_u={this.state.placeholderImage_u}
          nodeObjs={this.props.nodeObjs}
          unions={this.unions}
          focusNode={ this.props.chartType === 'fan' ? this.props.fanChartData.node.n: this.props.focusNode}
          isPedigree={this.props.isPedigree}
          chartType={this.props.chartType}
          focusPrId={this.props.focusPrId}
          nodeCount={this.props.nodeCount}
          ancestors={this.props.preferences.get('ancestors')}
          maxAncestorGen={this.props.maxAncestorGen}
          fanchartObj={this.props.fanchartObj}
          numOfGenerations={this.props.numOfGenerations}
          canvasHeight={this.props.canvasHeight}
          canvasWidth={this.props.canvasWidth}
          printModalVisible={this.state.printModalVisible}
          renderStageCanvasToImg={this.renderStageCanvasToImg.bind(this)}
          downloadingPedigreeChart={this.state.downloadingPedigreeChart}
          setStagePrintDownloadingTo={this.setStagePrintDownloadingTo.bind(this)}
          stagePrintCurrent={this.stage.current}
          fanchartCurrent={this.fanChartComponent.current}
          setPrintModalVisible={this.setPrintModalVisible.bind(this)}
          createImageElementForProfilePic={this.createImageElementForProfilePic.bind(this)}
          gatherNodesToFetchMoreData={this.gatherNodesToFetchMoreData.bind(this)}
          getEdgeOfTree={this.getEdgeOfTree.bind(this)}
          fetchIt={this.fetchIt.bind(this)}
          nodeNeedsFetchProfiles={this.nodeNeedsFetchProfiles.bind(this)}
          nodeIsDeadPerson={this.nodeIsDeadPerson.bind(this)}
          rightEdgeOfTree = {this.props.edges.get('right')}
          lowerPrintRes = {this.props.preferences.get('lowerPrintRes')} // printTreeResolution SuperTweak
          scalePrintCanvas = {this.props.preferences.get('scalePrintCanvas')} // printTreeResolution SuperTweak
          date_format = {this.props.preferences.get('date_format')}
          translatedLabels={this.translatedLabels}
        />
    )
  }


  showInititalProductTour(){

      const canShowProductTour = this.state.productTourVisible && !isMobilePhone() && typeof(this.props.preferences) !== 'undefined' && typeof(this.nodeObjs) !== 'undefined'  && typeof(this.stage) !== 'undefined';

      if( this.isProductTourWithFirstMaleGhostAndStartStepAtOne ){
        return canShowProductTour && this.state.profilesAllFetchedForFirstGhostNodeNeighbors
      } else {
        return canShowProductTour
      }

  }

  getRenderProductTour(){

    return (


          <ProductTour

            firstMaleGhostNode={this.props.firstMaleGhostNode}
            firstSmartMatchNode={this.props.firstSmartMatchNode}
            firstMultipleParentNode={this.props.firstMultipleParentNode}
            firstTreeMatchNode={this.props.firstTreeMatchNode}
            firstDeadNode={this.props.firstDeadNode}
            firstFemaleGhostNode={this.props.firstFemaleGhostNode}
            firstCycleMaster={this.props.firstCycleMaster}
            firstNodeWithPrune={this.state.firstNodeWithPrune}
            firstRecordMatchNode={this.props.firstRecordMatchNode}

            firstEditNode={this.props.firstEditNode}
            firstEmailRequestNode={this.props.firstEmailRequestNode}
            firstInconsistentencyNode={this.props.firstInconsistentencyNode}
            firstMergePendingNode={this.props.firstMergePendingNode}
            firstAppear05Node={this.props.firstAppear05Node}
            firstAppear06Node={this.props.firstAppear06Node}
            firstAppear07Node={this.props.firstAppear07Node}
            firstAppear08Node={this.props.firstAppear08Node}
            firstAppear09Node={this.props.firstAppear09Node}

            guide_page={this.props.preferences.get('guide_page')}
            show_guide={this.props.preferences.get('show_guide')}
            show_ancestors={this.props.preferences.get('show_ancestors')}

            focusNode={this.props.focusNode}
            nodeObjs={this.nodeObjs}
            canvasWidth={this.props.canvasWidth}
            canvasHeight={this.props.canvasHeight}
            canvasTop={this.props.canvasTop}
            shiftDownCanvasTop={this.props.shiftDownCanvasTop}
            translatedLabels={this.translatedLabels}
            postPreferences={this.props.postPreferences}
            postreduxpreferences={this.props.postreduxpreferences}
            flipPanelOpened={this.state.flipPanelOpened}
            navigationPanelIsUp={this.state.navigationPanelIsUp}
            autoStepping={this.state.autoStepping}
            lastStepNotifySeen={this.state.lastStepNotifySeen}
            notification={'publicWarning'}
            isPedigree={this.props.isPedigree}
            scaleX={( isMobilePhone() || typeof(this.stage.current.scaleX()) === 'undefined' ? undefined: this.stage.current.scaleX())}
            hideProductTour={this.hideProductTour.bind(this)}
            gotoFocusNode={this.gotoFocusNode.bind(this)}
            zoomAnimateCenterPedigree={this.zoomAnimateCenterPedigree.bind(this)}
            productTourForNodePoint={this.productTourForNodePoint.bind(this)}
            toggleFlipPanel={this.toggleFlipPanel.bind(this)}
            showMatchBubbleFor={this.showMatchBubbleFor.bind(this)}
            hideMatchBubble={this.hideMatchBubble.bind(this)}
            launchHelpCenterWindowinNewTab={this.launchHelpCenterWindowinNewTab.bind(this)}
          />
    )
  }

}


export default Desktop;
